<template>
    <div>
        <modal class="new-modal-default modal-outboxdd" :name="modal_name" transition="nice-modal-fade" :delay="100" height="auto"
            :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;border-radius: 11px !important">
                <!-- Header Section -->
                <div class="v-modal-header">
                    <span class="v-modal-dialog-title v-modal-title">
                        <span v-if="view_mode == 'create'">CREATE</span>
                        <span v-if="view_mode == 'edit'">EDIT</span>
                        <span v-if="view_mode == 'view'">VIEW</span>
                        REMINDER
                    </span>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left"
                            @click="hideCreateReminder"></span>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-center" style="height: 450px;" v-if="ajaxCallInprogress">
                    <half-circle-spinner :animation-duration="1000" :size="60"  color="#00448b" style="margin: 0 auto;" />
                </div>
                <div v-else class="v-modal-body overflow-hidden" style="overflow: visible;max-height: 480px;min-height: 230px; overflow-y: scroll;">
                    <div class="v-modal-layout px-3 py-2 pt-1">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="row">
                                    <div class="col-lg-6 col-md-12 col-sm-12 mt-2">
                                        <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">Reminder
                                            Type</span><sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup>
                                        <multiselect v-validate="'required'" name="reminder_type"
                                            class="diginew-multiselect-lightgrey border-blk no-default-icon down-arrow whiteSpace mt-2"
                                            :disabled="view_mode == 'edit' || view_mode == 'view' || meeting_type == 'meeting'" v-model="reminder_type"
                                            :clearable="false" :filterable="true" placeholder="Select Reminder Type"
                                            :options="['Follow Up', 'Task']">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Options Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <div class="text-danger float-left pl-0" v-show="errors.has('reminder_type')"
                                            style="text-transform: none !important;">Reminder Type is Required</div>
                                    </div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mt-2">
                                        <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">Reminder
                                            Name</span><sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup>
                                        <input type="text" name="reminder_name" class="input-field input-width mt-2"
                                            style="border: 1px solid #3f3f3f !important" v-validate="'required'"
                                            v-model="reminder_name" maxlength="100" placeholder="Enter Reminder Name"
                                            :disabled="view_mode == 'view'" />
                                            <!-- @input="checkReminderExist($event)" -->
                                        <div v-if="view_mode != 'view'" class="text-right mt-1">
                                            <span
                                                class="input-field-length float-right">{{ 100 - reminder_name.length }}/100</span>
                                        </div>
                                        <div class="text-danger float-left pl-0" v-show="errors.has('reminder_name')"
                                            style="text-transform: none !important;">Reminder Name is Required</div>
                                    </div>
                                </div>
                                <!-- Event Section -->
                                <div v-if="reminder_type == 'Event'" class="fs-14 fw-600 text-black mt-2 mb-2" >Schedule Reminder At</div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-12 col-sm-12 mt-2" v-if="reminder_type == 'Event'">
                                        <div class="d-flex">
                                            <div class="row">
                                                <div class="col-lg-7 col-md-7 col-sm-12">
                                                    <div class="w-100">
                                                        <span class="input-label text-secondary fw-600 pl-0 fs-14">Event Date<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></span>
                                                        <div class="d-flex align-items-center"
                                                            style="margin-top: .7rem !important;">
                                                            <date-picker v-validate="reminder_type == 'Event' ? 'required' : ''"
                                                                name="event_date" @change="checkDate('event')"
                                                                class="meetinfdatetime mx-left mx-cursor event-calendar-edit-per "
                                                                v-model="event_date" :disabled="view_mode == 'view'"
                                                                placeholder="Enter Event date" value-type="format" lang="en"
                                                                :not-before="new Date()" type="date" format="YYYY-MM-DD"
                                                                :clearable="false" :editable="false" confirm
                                                                confirm-text="APPLY">
                                                            </date-picker>
                                                        </div>
                                                        <div class="text-danger float-left pl-0"
                                                            v-show="errors.has('event_date')"
                                                            style="text-transform: none !important;">Event Date is Required
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-5 col-md-5 col-sm-12">
                                                    <div class="w-100">
                                                        <span class="input-label text-secondary fw-600 pl-0 fs-14">Event Time<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></span>
                                                        <el-select v-validate="reminder_type == 'Event' ? 'required' : ''"
                                                            name="event_time" class="mt-2 schedule_time" v-model="event_time"
                                                            style="border-radius: 6px;border: 1px solid #3f3f3f !important"
                                                            placeholder="Event Time" :popper-append-to-body="false"
                                                            :disabled="view_mode == 'view'">
                                                            <el-option v-for="(item, index) in time_format" :key="index"
                                                                :label="item" :value="item">
                                                            </el-option>
                                                        </el-select>
                                                        <div class="text-danger float-left pl-0"
                                                            v-show="errors.has('event_time')"
                                                            style="text-transform: none !important;">Event Time is Required
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mt-2" v-if="reminder_type == 'Event'">
                                        <span class="input-label text-secondary fw-600 fs-14" style="height:28px !important">Set Reminder</span>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="text-black fw-500 mr-2 fs-14">Before</span>
                                            <input class="input-field input-width text-center mr-2 p-1"
                                                v-validate="remind_period != '' ? 'required' : ''"
                                                :disabled="view_mode == 'view'"
                                                v-on:keypress="isNumber($event)" name="remind_cycle"
                                                v-model.number="remind_period" @input="checkNumber" type="number"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                style="min-height: 40px; height:40px !important; width: 55px !important; border-radius: 5px;border: 1px solid #3f3f3f" />
                                            <multiselect v-validate="remind_cycle != '' ? 'required' : ''" name="remind_period"
                                                :disabled="view_mode == 'view'" @close="changeRemindPeriod"
                                                class="diginew-multiselect-lightgrey ms-ht-custom border-blk no-default-icon down-arrow whiteSpace" v-model="temp_remind_cycle"
                                                :clearable="false" :filterable="true" placeholder="Select Option"
                                                :options="remind_period < 2 ? [ 'Day', 'Hour','Minute'] : [ 'Days', 'Hours','Minutes']">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Options Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <div class="text-right mt-1">
                                            <span class="float-left text-danger mb-3" v-show="errors.has('remind_cycle')">Remind
                                                Cycle is Required</span>
                                            <span class="float-left text-danger mb-3"
                                                v-show="errors.has('remind_period')">Remind Period is Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Follow Up and Task Section -->
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-6"
                                v-if="reminder_type == 'Follow Up' || reminder_type == 'Task'">
                                <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">Assigned To</span><sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup>
                                <multiselect
                                    v-validate="reminder_type == 'Follow Up' || reminder_type == 'Task' ? 'required' : ''"
                                    name="assigned_to"
                                    class="diginew-multiselect-lightgrey reminder-assign border-blk no-default-icon down-arrow mt-2"
                                    :disabled="view_mode == 'view'"
                                    v-model="assigned_to" placeholder="Select Assigned To" :options="members_options"
                                    track-by="id" label="full_name" :multiple="true" :searchable="true"
                                    :internal-search="true" :clear-on-select="true" :close-on-select="false"
                                    :options-limit="400" :max-height="200" :show-no-results="true"
                                    :hide-selected="false" :blockKeys="['Delete']" :loading="members_loading"
                                    @search-change="searchMembersData">
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfEmployees" />
                                    </template>
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">Options Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect>
                                <div class="text-danger float-left pl-0" v-show="errors.has('assigned_to')"
                                    style="text-transform: none !important;">Assigned To is Required</div>
                            </div>
                            <!-- Event Products -->
                            <div class="col-lg-4 col-md-12 col-sm-12 mt-2" v-if="reminder_type == 'Event'">
                                <span class="input-label text-secondary fw-600 pl-0">
                                    Products Name
                                </span>
                                <multiselect
                                    class="diginew-multiselect-longshort border-blk reminder-ms-custom-height greyblack no-default-icon mt-3"
                                    placeholder="Select Product"
                                    label="name" :max="10" 
                                    v-model="selected_event_products" @open="resetData('name')"
                                    :options="products_options" track-by="name" :disabled="view_mode == 'view'"
                                    :multiple="true" :searchable="true" :internal-search="true"
                                    :clear-on-select="false" :close-on-select="true" :options-limit="3000"
                                    :max-height="200" :show-no-results="true" :hide-selected="false"
                                    :blockKeys="['Delete']" :limit="1" :limit-text="limitProduct" :loading="products_loading" @search-change="searchProuctName"
                                >
                                    <template slot="option" slot-scope="props" class="d-flex">
                                        {{ props.option.name }}
                                    </template>
                                    <!-- <template slot="tag" slot-scope="{ option }">
                                        <span class="custom__tag">
                                        <span class="filterSelectedName">{{ option.name }}</span>
                                        </span>
                                    </template> -->
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfProductName" />
                                    </template>
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center font-weight-bold" >Product Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect>
                                <!-- <multiselect name="product_name" :max="10"
                                    class="diginew-multiselect-longshort event-reminder-product border-blk custom-short-ms greyblack no-default-icon mt-2"
                                    placeholder="Select Products" v-model="selected_event_products"
                                    :disabled="view_mode == 'view'" :multiple="true" :close-on-select="false"
                                    :show-labels="false" open-direction="bottom" :options="products" :max-height="190"
                                    :loading="products_loading" @search-change="searchProduct" label="name"
                                    trackBy="id">
                                    <template slot="option" slot-scope="props" class="d-flex">
                                        {{ props.option.name }}
                                    </template>
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfProducts" />
                                    </template>
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">Products Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect> -->
                                <!-- <div class="text-right mt-1">
                                    <span class="float-left text-danger mb-3"
                                        v-show="errors.has('product_name')">Products are Required</span>
                                </div> -->
                            </div>
                            <!-- <div v-if="reminder_type == 'Event'" class="col-lg-12 col-lg-12 col-sm-12 mt-6 mb-6">
                                <p class="fw-600" style="font-size: 15px;"><span class="pr-2">Repeat</span>
                                    <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                        <input type="checkbox" class="custom-control-input" @change="repeat($event)" v-model="repeatcheck"/>
                                        <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                        <span class="form-check-description fw-600"></span>
                                    </label>
                                </p>
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Start Date<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></div>
                                        <div class="">
                                            <date-picker
                                                v-validate="'required'" name="repeat_start_date"
                                                @change="clearRepeatEndDate"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-model="repeat_start_date"
                                                :not-before="new Date()"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm :disabled="repeat == false || view_mode == 'view'"
                                                confirm-text="APPLY"
                                            ></date-picker>
                                        </div>
                                        <div class="text-danger float-left pl-0"
                                            v-show="errors.has('repeat_start_date')"
                                            style="text-transform: none !important;">Start Date is Required
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-lg-4 col-sm-12">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">End Date <sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></div>
                                        <div class="">
                                            <date-picker
                                                :disabled="repeat_start_date == '' || view_mode == 'view'"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-validate="repeat_start_date != '' ? 'required' : ''" name="repeat_end_date"
                                                v-model="repeat_end_date"
                                                :not-before="new Date(repeat_start_date != '' ? disable_repeat_end_date : new Date())"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY"
                                                @change="calculateDifference()">
                                            </date-picker>
                                        </div>
                                        <div class="text-danger float-left pl-0"
                                            v-show="errors.has('repeat_end_date')"
                                            style="text-transform: none !important;">End Date is Required
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Cycle<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></div>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="text-black fw-500">Every</span>
                                            <input v-if="repeatcheck == false" class="text-center mx-2" maxlength="6" :disabled="repeatcheck == false || view_mode == 'view'" name="repeat_every_cycle" v-model.number="reminder_numbers" @input="checkNumberInRepeatCycle" type="number"  v-on:keypress="isNumber($event)" onkeypress="return event.charCode >= 48 && event.charCode <= 57" style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" />
                                            <input v-else type="text" v-validate="{max:10,regex: /^\d*\.?\d*$/}" v-on:keypress="checkDifference($event)"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46"
                                                style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" maxlength="10"
                                                class="text-center mx-2" v-model="reminder_number" name="repeat_every_cycle"
                                                :disabled="repeatcheck == false || view_mode == 'view'"/>
                                            <multiselect
                                                name="repeat_reminder_gap" v-validate="'required'"
                                                class="diginew-multiselect-lightgrey tools-rminders-repeat-cycle no-default-icon down-arrow whiteSpace"
                                                v-model="reminder_gap"
                                                :clearable="false"
                                                :filterable="true"
                                                placeholder="Select Option"
                                                :options="['Minute','Hour','Day', 'Month','Year']" @close="updateRepeatCycle(reminder_gap)">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Options Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <div class="text-danger float-left pl-0"
                                            v-show="errors.has('reminder_gap')"
                                            style="text-transform: none !important;">Cycle is Required
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-lg-6 col-md-12 col-sm-12 mt-3" v-if="reminder_type == 'Event'">
                                <span class="input-label text-secondary fw-600 pl-0">
                                    Send Invitation <sup v-if="view_mode != 'view'" class="text-danger fs-14">*</sup>
                                </span>
                                <multiselect v-validate="reminder_type == 'Event' ? 'required' : ''"
                                    name="send_invitees"
                                    class="diginew-multiselect-longshort border-blk reminder-ms-custom-mid-height greyblack no-default-icon mt-3"
                                    v-model="selected_invitees" :disabled="view_mode == 'view'"
                                    placeholder="Select Invitees" :options="members_invitees_options" :multiple="true"
                                    :close-on-select="false" open-direction="above" :show-labels="false" track-by="user_id" label="full_name"
                                    :searchable="true" :internal-search="true" :clear-on-select="false"
                                    :options-limit="400" :max-height="190" :show-no-results="true"
                                    :hide-selected="false" :blockKeys="['Delete']" :loading="members_invitees_loading"
                                    @search-change="searchInvitedMembersData">
                                    <template slot="tag"
                                        slot-scope="{ option}">
                                        <span class="custom__tag" :style="view_mode == 'view' ? 'cursor: not-allowed' : 'cursor: pointer'">
                                            <span style="font-weight: 600;">{{ option.full_name }}</span>
                                            <span class="custom__remove" style="margin-top: 4px;"
                                            :style="view_mode == 'view' ? 'cursor: not-allowed' : 'cursor: pointer'"
                                                @click="removeInvitees(option)">
                                                <i class="icon-close defaultDarkBlue" style="font-size: 15px !important;font-weight: 600;line-height: 15px !important;"></i>
                                            </span>
                                        </span>
                                    </template>
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfInvitedEmployees" />
                                    </template>
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">Options Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect>
                                <div class="text-right mt-1">
                                    <span class="float-left text-danger mb-3"
                                        v-show="errors.has('send_invitees')">Invitees are Required</span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 col-sm-12 mt-3" v-if="reminder_type == 'Event'">
                                <div>
                                    <span class="input-label fw-600 text-secondary">
                                        Notes
                                    </span>
                                    <textarea-autosize class="digi-textarea white-background bordered"
                                        placeholder="Add Notes" maxlength="500" v-model="event_notes"
                                        :disabled="view_mode == 'view'" style="height: 10.2em; overflow: auto;" />
                                    <div v-if="view_mode != 'view'" class="text-right mt-1">
                                        <span
                                            class="input-field-length float-right">{{ 500 - event_notes.length }}/500</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Follow Up Section -->
                        <div v-if="reminder_type == 'Follow Up'" class="fs-14 fw-600 text-black mt-2 mb-2" >Schedule Reminder At</div>
                        <div class="row" v-if="reminder_type == 'Follow Up'">
                            <div class="col-lg-4 col-md-12 col-sm-12">
                                <div class="row">
                                    <div class="col-lg-7 col-md-12 col-sm-12 mt-3">
                                        <div class="w-100">
                                            <span class="input-label text-secondary fw-600 fs-14">Due Date<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></span>
                                            <div class="d-flex align-items-center"
                                                style="margin-top: .7rem !important;">
                                                <date-picker v-validate="reminder_type == 'Follow Up' ? 'required' : ''"
                                                    name="due_date" :disabled="view_mode == 'view'"  @change="checkDate('follow_up'), followupSetReminderOptions()"
                                                    class="meetinfdatetime mx-left mx-cursor calendar-edit-per"
                                                    v-model="due_date" value-type="format" lang="en"
                                                    placeholder="Select Due Date" :not-before="new Date()" type="date"
                                                    format="YYYY-MM-DD" :clearable="false" :editable="false" confirm
                                                    confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                            <div class="text-danger float-left pl-0" v-show="errors.has('due_date')"
                                                style="text-transform: none !important;">Due Date is Required</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-12 col-sm-12 mt-3">
                                        <div class="w-100">
                                            <span class="input-label text-secondary fw-600 fs-14">Due Time<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></span>
                                            <div class="d-flex align-items-center"
                                                style="margin-top: .7rem !important;">
                                                <el-select v-validate="reminder_type == 'Follow Up' ? 'required' : ''"
                                                    name="due_time" class="mt-0 schedule_time w-100" v-model="due_time"
                                                    style="border-radius: 6px;border: 1px solid #3f3f3f !important;"
                                                    @change="followupSetReminderOptions()"
                                                    placeholder="Select Due Time" :disabled="view_mode == 'view'"
                                                    :popper-append-to-body="false">
                                                    <el-option v-for="(item, index) in time_format" :key="index"
                                                        :label="item" :value="item">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                            <div class="text-danger float-left pl-0" v-show="errors.has('due_time')"
                                                style="text-transform: none !important;">Due Time is Required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-12 col-sm-12">
                                <div class="input-label text-secondary fw-600 fs-14 pl-0 pt-3">Set Reminder</div>
                                <div class="d-flex align-items-center">
                                    <span class="text-black fw-500 mr-2 fs-14">Before</span>
                                    <input class="input-field input-width text-center mr-2 p-1"
                                        v-validate="remind_period != '' ? 'required' : ''"
                                        :disabled="view_mode == 'view'"
                                        @change="followupSetReminderOptions()" name="remind_cycle"
                                        v-model.number="remind_period" @input="checkNumber" type="text"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                        style="min-height: 40px; height:40px !important; width: 70px !important; border-radius: 5px;border: 1px solid #3f3f3f" />
                                    <multiselect v-validate="remind_cycle != '' ? 'required' : ''" name="remind_period"
                                        :disabled="view_mode == 'view' || due_date == '' || due_time == ''" @close="changeRemindPeriod"
                                        class="diginew-multiselect-lightgrey ms-ht-custom border-blk no-default-icon down-arrow whiteSpace pl-2" v-model="temp_remind_cycle"
                                        :clearable="false" :filterable="true" placeholder="Select Option"
                                        :options="set_reminder_options">
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Options Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="text-right mt-1">
                                    <span class="float-left text-danger mb-3" v-show="errors.has('remind_cycle')">Remind
                                        Cycle is Required</span>
                                    <span class="float-left text-danger mb-3"
                                        v-show="errors.has('remind_period')">Remind Period is Required</span>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-12 col-sm-12">
                                <div class="input-label text-black fw-600 fs-14 pl-0 pt-3">Repeat</div>
                                <multiselect name="repeat_followup"
                                    :disabled="view_mode == 'view'"
                                    class="diginew-multiselect-lightgrey ms-ht-custom border-blk no-default-icon down-arrow whiteSpace" v-model="repeat_reminder"
                                    :clearable="false" :filterable="true" placeholder="Select Repeat"
                                    :options="repeat_reminder_options" :allow-empty="false">
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">Options Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect> 
                            </div>
                            <!-- <div class="col-lg-4 col-md-12 col-sm-12">
                                <div class="row mt-2">
                                    <div class="col-lg-4 col-md-14 col-sm-6">
                                        <div class="input-label text-secondary fw-600 fs-14 pl-0" style="height: 31px !important;">
                                            Price
                                            <sup class="fs-14 pl-1">
                                                <el-tooltip class="item" effect="dark" content="Product Value" placement="top">
                                                    <i class="icon icon-information text-secondary fs-18"></i>
                                                </el-tooltip>
                                            </sup>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <input type="text" disabled name="currency" v-model="currency" style="border: 1px solid #3f3f3f;height: 40px !important;width: 85px !important;"
                                                class="input-field input-width text-center" placeholder="" />
                                        </div>
                                    </div>
                                    <div class="col-lg-8 col-md-10 col-sm-6 pl-2">
                                        <div class="input-label text-secondary fw-600 fs-14 pl-0" style="height: 31px !important;">
                                            Budget
                                            <sup class="text-danger fs-14 pl-1" >
                                                <el-tooltip class="item" effect="dark" content="N/A" placement="top">
                                                    <i class="icon icon-information text-secondary fs-18"></i>
                                                </el-tooltip>
                                            </sup>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <input type="text" name="price" v-validate="{max:12,regex: /^\d*\.?\d*$/}"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46"
                                                style="border: 1px solid #3f3f3f !important;height: 40px !important;" data-vv-as="Price" maxlength="12"
                                                class="input-field price-field input-width" v-model="price"
                                                :disabled="view_mode == 'view'" placeholder="N/A" />
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mt-1">
                                    <span class="float-left text-danger mb-3" v-show="errors.has('price')">{{errors.first('price')}}</span>
                                </div> 
                            </div> -->
                            <!-- <div v-if="reminder_type == 'Follow Up'" class="col-lg-12 col-lg-12 col-sm-12 mt-6 mb-6">
                                <p class="fw-600" style="font-size: 15px;"><span class="pr-2">Repeat</span>
                                    <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                        <input type="checkbox" class="custom-control-input" :disabled="view_mode == 'view'" @change="repeat($event)" v-model="repeatcheck"/>
                                        <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                        <span class="form-check-description fw-600"></span>
                                    </label>
                                </p>
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12"  v-if="repeatcheck != false">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Start Date<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></div>
                                        <div class="">
                                            <date-picker
                                                v-validate="'required'" name="repeat_start_date"
                                                @change="clearRepeatEndDate"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-model="repeat_start_date"
                                                :not-before="new Date(new Date(due_date != '' ? disable_repeat_start_date : new Date()))"
                                                lang="en" :disabled="view_mode == 'view' || due_date == ''"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY"
                                            ></date-picker>
                                        </div>
                                        <div class="text-danger float-left pl-0"
                                            v-show="errors.has('repeat_start_date')"
                                            style="text-transform: none !important;">Start Date is Required
                                        </div>
                                    </div>
                                    <div v-else class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Start Date</div>
                                        <div class="">
                                            <date-picker 
                                                @change="clearRepeatEndDate"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-model="repeat_start_date"
                                                :not-before="new Date()"
                                                lang="en" :disabled="repeatcheck == false || view_mode == 'view'"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-lg-4 col-sm-12" v-if="repeatcheck != false">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">End Date <sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></div>
                                        <div class="">
                                            <date-picker
                                                :disabled="repeat_start_date == '' || view_mode == 'view'"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-validate="repeat_start_date != '' ? 'required' : ''" name="repeat_end_date"
                                                v-model="repeat_end_date" @change="cycleOptions(), calculateDifference()"
                                                :not-before="new Date(new Date(repeat_start_date != '' ? disable_repeat_end_date : new Date()))"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY">
                                            </date-picker>
                                        </div>
                                        <div class="text-danger float-left pl-0"
                                            v-show="errors.has('repeat_end_date')"
                                            style="text-transform: none !important;">End Date is Required
                                        </div>
                                    </div>
                                    <div v-else class="col-lg-4 col-lg-4 col-sm-12">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">End Date</div>
                                        <div class="">
                                            <date-picker
                                                :disabled="repeat_start_date == '' || view_mode == 'view'"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-model="repeat_end_date" @change="cycleOptions(), calculateDifference()"
                                                :not-before="new Date(new Date(repeat_start_date != '' ? disable_repeat_end_date : new Date()))"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY">
                                            </date-picker>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12" v-if="repeatcheck != false">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Cycle<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></div>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="text-black fw-500">Every</span>
                                            <input v-if="repeatcheck == false" class="text-center mx-2" maxlength="6" type="text" v-validate="{max:12,regex: /^\d*\.?\d*$/}" :disabled="repeatcheck == false || view_mode == 'view'" name="repeat_every_cycle" v-model="reminder_numbers" @input="checkNumberInRepeatCycle" onkeypress="return event.charCode >= 48 && event.charCode <= 57" style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" />
                                            <input v-else type="text" v-validate="{max:10,regex: /^\d*\.?\d*$/}" @input="checkDifference($event)"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46"
                                                style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" maxlength="10"
                                                class="text-center mx-2" v-model="reminder_number" name="repeat_every_cycle"
                                                :disabled="repeatcheck == false || view_mode == 'view' || repeat_end_date == ''"/>
                                            <multiselect
                                                name="reminder_gap" v-validate="'required'"
                                                class="diginew-multiselect-lightgrey tools-rminders-repeat-cycle no-default-icon down-arrow whiteSpace"
                                                v-model="reminder_gap"
                                                :clearable="false"
                                                :filterable="true" :disabled="repeatcheck == false || view_mode == 'view' || repeat_end_date == ''"
                                                placeholder="Select Option"
                                                :options="cycle_options" @close="updateRepeatCycle(reminder_gap)">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Options Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <div class="text-danger float-left pl-0"
                                            v-show="errors.has('reminder_gap')">Cycle is Required
                                        </div>
                                    </div>
                                    <div v-else class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Cycle</div>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="text-black fw-500">Every</span>
                                            <input v-if="repeatcheck == false" class="text-center mx-2" maxlength="6" type="text" v-validate="{max:12,regex: /^\d*\.?\d*$/}" :disabled="repeatcheck == false || view_mode == 'view'" name="repeat_every_cycle" v-model="reminder_numbers" @input="checkNumberInRepeatCycle" onkeypress="return event.charCode >= 48 && event.charCode <= 57" style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" />
                                            <input v-else type="text" v-validate="{max:10,regex: /^\d*\.?\d*$/}"  @input="checkDifference($event)"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46"
                                                style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" maxlength="10"
                                                class="text-center mx-2" v-model="reminder_number" name="repeat_every_cycle"
                                                :disabled="repeatcheck == false || view_mode == 'view' || repeat_end_date == ''"/>
                                            <multiselect
                                                name="repeat_reminder_gap"
                                                class="diginew-multiselect-lightgrey tools-rminders-repeat-cycle no-default-icon down-arrow whiteSpace"
                                                v-model="reminder_gap"
                                                :clearable="false"
                                                :filterable="true" :disabled="repeatcheck == false || view_mode == 'view' || repeat_end_date == ''"
                                                placeholder="Select Option"
                                                :options="['Minute','Hour','Day', 'Month','Year']" @close="updateRepeatCycle(reminder_gap)">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Options Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-3 pt-4">
                                <span class="input-label text-secondary fw-600 pl-0">
                                    Products Name
                                </span>
                                <multiselect
                                    class="diginew-multiselect-longshort border-blk reminder-ms-custom-height greyblack no-default-icon mt-3" :max="10"
                                    placeholder="Select Product"
                                    label="name"
                                    v-model="selected_event_products" @open="resetData('name')"
                                    :options="products_options" track-by="name" :disabled="view_mode == 'view'"
                                    :multiple="true" :searchable="true" :internal-search="true"
                                    :clear-on-select="false" :close-on-select="true" :options-limit="3000"
                                    :max-height="200" :show-no-results="true" :hide-selected="false"
                                    :blockKeys="['Delete']" :limit="1" :limit-text="limitProduct" :loading="products_loading" @search-change="searchProuctName"
                                >
                                    <template slot="option" slot-scope="props" class="d-flex">
                                        {{ props.option.name }}
                                    </template>
                                    <!-- <template slot="tag" slot-scope="{ option }">
                                        <span class="custom__tag">
                                        <span class="filterSelectedName">{{ option.name }}</span>
                                        </span>
                                    </template> -->
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfProductName" />
                                    </template>
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center font-weight-bold" >Product Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect>
                                <!-- class="diginew-multiselect-longshort border-blk reminder-ms-custom-mid-height greyblack no-default-icon mt-3" -->
                                <!-- <multiselect name="product_name" :max="10"
                                    class="diginew-multiselect-longshort border-blk custom-short-ms greyblack no-default-icon mt-2 followup-productselection"
                                    placeholder="Select Products" v-model="selected_followup_products"
                                    :disabled="view_mode == 'view'" :multiple="true" :close-on-select="false"
                                    :show-labels="false" :options="products" :max-height="190" open-direction="above"
                                    :loading="products_loading" @search-change="searchProduct" label="name"
                                    trackBy="id">
                                    <template slot="option" slot-scope="props" class="d-flex">
                                        {{ props.option.name }}
                                    </template>
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfProducts" />
                                    </template>
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">Products Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect> -->
                                <!-- <div class="text-right mt-1">
                                    <span class="float-left text-danger mb-3"
                                        v-show="errors.has('product_name')">Products are Required</span>
                                </div> -->
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-3 pt-4">
                                <div>
                                    <span class="input-label text-secondary fw-600">
                                        Notes
                                    </span>
                                    <textarea-autosize class="digi-textarea white-background bordered mt-2"
                                        placeholder="Add Notes" maxlength="500" v-model="followup_notes"
                                        :disabled="view_mode == 'view'" style="height: 9em; overflow: auto;" />
                                    <div v-if="view_mode != 'view'" class="text-right mt-1">
                                        <span
                                            class="input-field-length float-right">{{ 500 - followup_notes.length }}/500</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
                                <div>
                                    <span class="input-label text-secondary fw-600">
                                        Attachments
                                    </span>
                                    <div v-if="view_mode != 'view' && attachments.length < 5" class="upload-main d-flex flex-column justify-content-center align-items-center attachment-bg pl-0">
                                        <div class="d-flex justify-content-center align-items-center mt-8">
                                            <div class="mb-10">
                                                <img class="upload-img"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/upload-icon.svg"><br>
                                                <span class="fs-14 fw-500 mt-2 mr-3">Drag and Drop File or </span>
                                            </div>
                                            <file-upload
                                                :class="{'pointer-event':attachments.length >= 5}"
                                                class="choose-file btn btn-new-primary mt-2"
                                                :multiple="true" :drop="true"
                                                :drop-directory="true"
                                                accept=".doc, .docx, .pdf, .txt, .Xls, .xlsx, .jpeg, .png, .svg,"
                                                @input-file="uploadAttachment" ref="upload"
                                                style="text-transform: none !important">
                                                Browse
                                            </file-upload>
                                        </div>
                                    </div>
                                    <div v-if="attachments.length" class="row">
                                        <div class="attachmentsdiv p-4 my-2 col-4 mr-6 ml-4" v-for="(attachment,index) in attachments" :key="index">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                        <img class="icon-img"
                                                            v-if="attachment.name.endsWith('.pdf')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.png')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.jpg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.svg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.xls')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.doc')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/doc-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.docx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.htm')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/htm-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.html')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/html-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.ppt')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.pptx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.txt')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/txt-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.xlsx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.bmp')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/bmp-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.gif')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.jpeg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.tiff')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.avi')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/avi-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.flv')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/flv-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mpg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mpeg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpeg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mp3')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mp4')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.wav')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wav-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.wmv')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wmv-icon.svg" />
                                                    </div>
                                                    <div class="col">
                                                        <div class="d-flex justify-content-between">
                                                            <el-tooltip :content="attachment.name" placement="top">
                                                                <div class="font-weight-bold text-truncate d-block mx-width-220"> {{attachment.name}}</div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-if="attachment.uploading || attachment.url == undefined">
                                                            <progress-bar
                                                                class="progressBar w-100"
                                                                :class="{'error-upload':attachment.url == undefined}"
                                                                :val="attachment.progress"
                                                                size="small">
                                                            </progress-bar>
                                                        </div>
                                                        <div
                                                            class="d-flex justify-content-between">
                                                            <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">
                                                                {{attachment.error}}...</div>
                                                            <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">
                                                                {{attachment.progress}}% Uploading</div>
                                                            <!-- <div class="text-secondary fw-500" v-if="attachment.progress==100 && attachment.error == ''">
                                                                {{attachment.progress}}% Uploaded</div> -->
                                                            <div class="fw-500">
                                                                ({{attachment.size | prettyBytes}})
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined"
                                                    class="pointer" @click="deleteAttachment(index)">
                                                    <i class="icon icon-close fs-16 closeAttachment"></i>
                                                </div>
                                                <div v-else-if="view_mode != 'view'" class="pointer" @click="deleteAttachment(index)">
                                                    <i class="icon icon-close fs-16 closeAttachment"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Task Section -->
                        <div v-if="reminder_type == 'Task'" class="fs-14 fw-600 text-black mt-2 mb-2" >Schedule Reminder At</div>
                        <div class="row" v-if="reminder_type == 'Task'">
                            <div class="col-lg-8 col-md-12 col-sm-12">
                                <div class="row">
                                    <div class="col-lg-6 col-md-12 col-sm-12 mt-2">
                                        <div class="d-flex">
                                            <div class="row">
                                                <div class="col-lg-7 col-md-7 col-sm-12">
                                                    <div class="w-100">
                                                        <span class="input-label text-secondary fw-600 fs-14">Reminder
                                                            Date</span><sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup>
                                                        <div class="d-flex align-items-center"
                                                            style="margin-top: .7rem !important;">
                                                            <date-picker
                                                                v-validate="reminder_type == 'Task' ? 'required' : ''"
                                                                name="due_date"  @change="checkDate('task'), followupSetReminderOptions()"
                                                                class="meetinfdatetime mx-left mx-cursor calendar-edit-per"
                                                                v-model="due_date" :disabled="view_mode == 'view'"
                                                                placeholder="Enter Reminder Date" value-type="format"
                                                                lang="en" :not-before="new Date()" type="date"
                                                                format="YYYY-MM-DD" :clearable="false" :editable="false"
                                                                confirm confirm-text="APPLY">
                                                            </date-picker>
                                                        </div>
                                                        <div class="text-danger float-left pl-0"
                                                            v-show="errors.has('due_date')"
                                                            style="text-transform: none !important;">Reminder Date is
                                                            Required</div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-5 col-md-5 col-sm-12">
                                                    <div class="w-100">
                                                        <span class="input-label text-secondary fw-600 fs-14 text-nowrap">Reminder Time<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></span>
                                                        <el-select
                                                            v-validate="reminder_type == 'Task' ? 'required' : ''"
                                                            name="due_time" class="mt-2 schedule_time"
                                                            v-model="due_time"
                                                            style="border-radius: 6px;border: 1px solid #3f3f3f !important;"
                                                            :disabled="view_mode == 'view'" placeholder="Reminder Time"
                                                            @change="followupSetReminderOptions()"
                                                            :popper-append-to-body="false">
                                                            <el-option v-for="(item, index) in time_format" :key="index"
                                                                :label="item" :value="item">
                                                            </el-option>
                                                        </el-select>
                                                        <div class="text-danger float-left pl-0"
                                                            v-show="errors.has('due_time')"
                                                            style="text-transform: none !important;">Reminder Time is
                                                            Required</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-12 col-sm-12">
                                        <div class="input-label text-secondary fw-600 fs-14 pl-0 pt-2">Set Reminder</div>
                                        <div class="d-flex align-items-center">
                                            <span class="text-black fw-500 fs-14 mr-2">Before</span>
                                            <input class="input-field input-width text-center mr-2 p-1"
                                                v-validate="remind_period != '' ? 'required' : ''"
                                                @change="followupSetReminderOptions()" name="remind_cycle" :disabled="view_mode == 'view'"
                                                v-model.number="remind_period" @input="checkNumber" type="text"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                style="min-height: 40px; height:40px !important; width: 55px !important; border-radius: 5px;border: 1px solid #3f3f3f" />
                                            <multiselect v-validate="remind_cycle != '' ? 'required' : ''"
                                                name="remind_period" :disabled="view_mode == 'view' || due_date == '' || due_time == ''" @close="changeRemindPeriod"
                                                class="diginew-multiselect-lightgrey ms-ht-custom border-blk no-default-icon down-arrow whiteSpace"
                                                v-model="temp_remind_cycle" :clearable="false" :filterable="true"
                                                placeholder="Select Option" :options="set_reminder_options">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Options Not Found
                                                    </div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <div class="text-right mt-1">
                                            <span class="float-left text-danger mb-3"
                                                v-show="errors.has('remind_cycle')">Remind Cycle is Required</span>
                                            <span class="float-left text-danger mb-3"
                                                v-show="errors.has('remind_period')">Remind Period is Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-12 col-sm-12">
                                <div class="input-label text-black fw-600 fs-14 pl-0 pt-2">Repeat</div>
                                <multiselect name="repeat_followup"
                                    :disabled="view_mode == 'view'"
                                    class="diginew-multiselect-lightgrey ms-ht-custom border-blk no-default-icon down-arrow whiteSpace" v-model="repeat_reminder"
                                    :clearable="false" :filterable="true" placeholder="Select Repeat"
                                    :options="repeat_reminder_options" :allow-empty="false">
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">Options Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect> 
                            </div>
                            <!-- <div v-if="reminder_type == 'Task'" class="col-lg-12 col-lg-12 col-sm-12 mt-6 mb-6">
                                <p class="fw-600" style="font-size: 15px;"><span class="pr-2">Repeat</span>
                                    <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                        <input type="checkbox" :disabled="view_mode == 'view'" class="custom-control-input" @change="repeat($event)" v-model="repeatcheck"/>
                                        <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                        <span class="form-check-description fw-600"></span>
                                    </label>
                                </p>
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12" v-if="repeatcheck == false">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Start Date</div>
                                        <div class="">
                                            <date-picker
                                                @change="clearRepeatEndDate"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-model="repeat_start_date"
                                                :not-before="new Date()"
                                                lang="en" :disabled="repeatcheck == false || view_mode == 'view'"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <div v-else class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Start Date<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></div>
                                        <div class="">
                                            <date-picker
                                                v-validate="'required'" name="repeat_start_date"
                                                @change="clearRepeatEndDate"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-model="repeat_start_date"
                                                :not-before="new Date(new Date(due_date != '' ? disable_repeat_start_date : new Date()))"
                                                lang="en" :disabled="view_mode == 'view' || due_date == ''"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY"
                                            ></date-picker>
                                        </div>
                                        <div class="text-danger float-left pl-0"
                                            v-show="errors.has('repeat_start_date')"
                                            style="text-transform: none !important;">Start Date is Required
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-lg-4 col-sm-12" v-if="repeatcheck == false">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">End Date</div>
                                        <div class="">
                                            <date-picker
                                                :disabled="repeat_start_date == '' || view_mode == 'view'"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-model="repeat_end_date" @change="cycleOptions"
                                                :not-before="new Date(new Date(repeat_start_date != '' ? disable_repeat_end_date : new Date()))"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY">
                                            </date-picker>
                                        </div>
                                    </div>
                                    <div v-else class="col-lg-4 col-lg-4 col-sm-12">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">End Date <sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></div>
                                        <div class="">
                                            <date-picker
                                                :disabled="repeat_start_date == '' || view_mode == 'view'"
                                                class="toolsRminderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-validate="repeat_start_date != '' ? 'required' : ''" name="repeat_end_date"
                                                v-model="repeat_end_date" @change="cycleOptions"
                                                :not-before="new Date(new Date(repeat_start_date != '' ? disable_repeat_end_date : new Date()))"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY">
                                            </date-picker>
                                        </div>
                                        <div class="text-danger float-left pl-0"
                                            v-show="errors.has('repeat_end_date')"
                                            style="text-transform: none !important;">End Date is Required
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12" v-if="repeatcheck != false">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Cycle<sup v-if="view_mode != 'view'" class="text-danger fs-14 pl-1">*</sup></div>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="text-black fw-500">Every</span>
                                            <input v-if="repeatcheck == false" class="text-center mx-2" maxlength="6" type="text" v-validate="{max:12,regex: /^\d*\.?\d*$/}" :disabled="repeatcheck == false || view_mode == 'view'" name="repeat_every_cycle" v-model="reminder_numbers" @input="checkNumberInRepeatCycle" onkeypress="return event.charCode >= 48 && event.charCode <= 57" style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" />
                                            <input v-else type="text" v-validate="{max:10,regex: /^\d*\.?\d*$/}"  @input="checkDifference($event)"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46"
                                                style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" maxlength="10"
                                                class="text-center mx-2" v-model="reminder_number" name="repeat_every_cycle"
                                                :disabled="repeatcheck == false || view_mode == 'view' || repeat_end_date == ''"/>
                                            <multiselect
                                                name="reminder_gap"
                                                class="diginew-multiselect-lightgrey tools-rminders-repeat-cycle no-default-icon down-arrow whiteSpace"
                                                v-model="reminder_gap"
                                                :clearable="false" v-validate="'required'"
                                                :filterable="true" :disabled="repeatcheck == false || view_mode == 'view' || repeat_end_date == ''"
                                                placeholder="Select Option"
                                                :options="cycle_options" @close="updateRepeatCycle(reminder_gap)">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Options Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <div class="text-danger float-left pl-0"
                                            v-show="errors.has('reminder_gap')">Cycle is Required
                                        </div>
                                    </div>
                                    <div v-else class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="mb-1 input-label text-secondary fw-600 fs-14" style="height: 22px !important;">Cycle</div>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="text-black fw-500">Every</span>
                                            <input v-if="repeatcheck == false" class="text-center mx-2" maxlength="6" type="text" v-validate="{max:12,regex: /^\d*\.?\d*$/}" :disabled="repeatcheck == false || view_mode == 'view'" name="repeat_every_cycle" v-model="reminder_numbers" @input="checkNumberInRepeatCycle" onkeypress="return event.charCode >= 48 && event.charCode <= 57" style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" />
                                            <input v-else type="text" v-validate="{max:10,regex: /^\d*\.?\d*$/}"  @input="checkDifference($event)"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46"
                                                style="min-height: 40px; width: 55px; border: solid 1px #000; border-radius: 6px !important;font-weight: 600;" maxlength="10"
                                                class="text-center mx-2" v-model="reminder_number" name="repeat_every_cycle"
                                                :disabled="repeatcheck == false || view_mode == 'view' || repeat_end_date == ''"/>
                                            <multiselect
                                                name="repeat_reminder_gap"
                                                class="diginew-multiselect-lightgrey tools-rminders-repeat-cycle no-default-icon down-arrow whiteSpace"
                                                v-model="reminder_gap"
                                                :clearable="false"
                                                :filterable="true" :disabled="repeatcheck == false || view_mode == 'view' || repeat_end_date == ''"
                                                placeholder="Select Option"
                                                :options="cycle_options" @close="updateRepeatCycle(reminder_gap)">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Options Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-3 pt-4">
                                <span class="input-label text-secondary fw-600 pl-0">
                                    Products Name
                                </span>
                                <multiselect
                                    class="diginew-multiselect-longshort border-blk reminder-ms-custom-height greyblack no-default-icon mt-3" :max="10"
                                    placeholder="Select Product"
                                    label="name"
                                    v-model="selected_event_products" @open="resetData('name')"
                                    :options="products_options" track-by="name"
                                    :multiple="true" :disabled="view_mode == 'view'" :searchable="true" :internal-search="true"
                                    :clear-on-select="false" :close-on-select="true" :options-limit="3000"
                                    :max-height="200" :show-no-results="true" :hide-selected="false"
                                    :blockKeys="['Delete']" :limit="1" :limit-text="limitProduct" :loading="products_loading" @search-change="searchProuctName"
                                >
                                    <template slot="option" slot-scope="props" class="d-flex">
                                        {{ props.option.name }}
                                    </template>
                                    <!-- <template slot="tag" slot-scope="{ option }">
                                        <span class="custom__tag">
                                        <span class="filterSelectedName">{{ option.name }}</span>
                                        </span>
                                    </template> -->
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfProductName" />
                                    </template>
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center font-weight-bold" >Product Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect>
                                <!-- <multiselect name="product_name" :max="10"
                                    class="diginew-multiselect-longshort border-blk reminder-ms-custom-height greyblack no-default-icon mt-3"
                                    placeholder="Select Products" v-model="selected_followup_products" :multiple="true"
                                    :disabled="view_mode == 'view'" :close-on-select="true" :show-labels="false"
                                    :options="products" :loading="products_loading" @search-change="searchProduct"
                                    label="name" :max-height="190" trackBy="id">
                                    <template slot="option" slot-scope="props" class="d-flex">
                                        {{ props.option.name }}
                                    </template>
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfProducts" />
                                    </template>
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">Products Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect> -->
                                <!-- <div class="text-right mt-1">
                                    <span class="float-left text-danger mb-3"
                                        v-show="errors.has('product_name')">Products are Required</span>
                                </div> -->
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-3 pt-4">
                                <div>
                                    <span class="input-label text-secondary fw-600">
                                        Notes
                                    </span>
                                    <textarea-autosize class="digi-textarea white-background bordered"
                                        placeholder="Add Notes" maxlength="500" v-model="followup_notes"
                                        :disabled="view_mode == 'view'" style="height: 10em; overflow: auto;" />
                                    <div v-if="view_mode != 'view'" class="text-right mt-1">
                                        <span
                                            class="input-field-length float-right">{{ 500 - followup_notes.length }}/500</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
                                <div>
                                    <span class="input-label text-secondary fw-600">
                                        Attachments
                                    </span>
                                    <div v-if="view_mode != 'view' && attachments.length < 5" class="upload-main d-flex flex-column justify-content-center align-items-center attachment-bg pl-0">
                                        <div class="d-flex justify-content-center align-items-center mt-8">
                                            <div class="mb-10">
                                                <img class="upload-img"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/upload-icon.svg"><br>
                                                <span class="fs-14 fw-500 mt-2 mr-3">Drag and Drop File or </span>
                                            </div>
                                            <file-upload
                                                :class="{'pointer-event':attachments.length >= 5}"
                                                class="choose-file btn btn-new-primary mt-2"
                                                :multiple="true" :drop="true"
                                                :drop-directory="true"
                                                accept=".doc, .docx, .pdf, .txt, .Xls, .xlsx, .jpeg, .png, .svg,"
                                                @input-file="uploadAttachment" ref="upload"
                                                style="text-transform: none !important">
                                                Browse
                                            </file-upload>
                                        </div>
                                    </div>
                                    <div v-if="attachments.length" class="row">
                                        <div class="attachmentsdiv p-4 my-2 col-4 mr-6 ml-4" v-for="(attachment,index) in attachments" :key="index">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                        <img class="icon-img"
                                                            v-if="attachment.name.endsWith('.pdf')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.png')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.jpg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.svg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.xls')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.doc')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/doc-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.docx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.htm')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/htm-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.html')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/html-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.ppt')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.pptx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.txt')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/txt-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.xlsx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.bmp')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/bmp-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.gif')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.jpeg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.tiff')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.avi')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/avi-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.flv')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/flv-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mpg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mpeg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpeg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mp3')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mp4')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.wav')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wav-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.wmv')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wmv-icon.svg" />
                                                    </div>
                                                    <div class="col">
                                                        <div class="d-flex justify-content-between">
                                                            <el-tooltip :content="attachment.name" placement="top">
                                                                <div class="font-weight-bold text-truncate d-block mx-width-220"> {{attachment.name}}</div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-if="attachment.uploading || attachment.url == undefined">
                                                            <progress-bar
                                                                class="progressBar w-100"
                                                                :class="{'error-upload':attachment.url == undefined}"
                                                                :val="attachment.progress"
                                                                size="small">
                                                            </progress-bar>
                                                        </div>
                                                        <div
                                                            class="d-flex justify-content-start">
                                                            <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">
                                                                {{attachment.error}}</div>
                                                            <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">
                                                                {{attachment.progress}}% Uploading</div>
                                                            <!-- <div class="text-secondary fw-500" v-if="attachment.progress==100 && attachment.error == ''">
                                                                {{attachment.progress}}% Uploaded</div> -->
                                                            <div class="fw-500">
                                                                ({{attachment.size | prettyBytes}})
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined"
                                                    class="pointer" @click="deleteAttachment(index)">
                                                    <i class="icon icon-close fs-16 closeAttachment"></i>
                                                </div>
                                                <div v-else-if="view_mode != 'view'" class="pointer" @click="deleteAttachment(index)">
                                                    <i class="icon icon-close fs-16 closeAttachment"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!ajaxCallInprogress" class="v-modal-footer mb-4">
                    <div class="v-modal-dialog-actions d-flex justify-content-center align-items-center mt-2"
                        v-if="(view_mode == 'create' || view_mode == 'edit') && disableButtonAndDisplayLoader == false">
                        <button class="btn new-cancel-button ml-2 mr-2" style="width:120px" @click="hideCreateReminder" :disabled="isUploadingInProgress">Cancel</button>
                        <button class="btn new-save-button ml-2 mr-2" v-if="view_mode == 'edit' && repeat_reminder != 'Does not Repeat' && old_reminder_data != 'never'" style="width:120px" :disabled="isUploadingInProgress || fields_not_changed" @click="updateType">Save</button>
                        <button class="btn new-save-button ml-2 mr-2" v-else style="width:120px" :disabled="isUploadingInProgress || fields_not_changed" @click="SaveRemainder">Save</button>
                        <!-- v-if="saveInProgress == false" -->
                    </div>
                    <div v-if="disableButtonAndDisplayLoader == true" class="v-modal-dialog-actions d-flex justify-content-center align-items-center mt-2">
                        <button class="btn new-cancel-button ml-2 mr-2" style="width:120px;border: 1px solid transparent !important;" disabled>Cancel</button>
                        <button class="btn btn-des-small ml-2 mr-2" style="color: #fff;position: relative; background: #1a9347;width:120px" disabled>Save
                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                    </div>
                    <!-- && reminderType != 'Invitations' && origin != 'call_report' -->
                    <!-- <div class="v-modal-dialog-actions d-flex justify-content-center align-items-center mt-2"
                        v-if="(view_mode == 'view' && reminder_status == 'pending')">
                        <button class="btn btn-des-small ml-2 mr-2" v-if="can_edit"
                            style="color: #00448b; border: 1px solid #00448b; background: #fff;width:180px" @click="view_mode = 'edit'">
                            <i class="icon icon-pencil text-secondary"></i> Edit 
                        </button>
                        <button class="btn btn-des-small ml-2 mr-2"
                            style="color: #fff; background: #008a63; border: 1px solid #008a63;width:180px"
                            @click="MarkComplete">Mark as Complete
                        </button>
                    </div> -->
                    <!-- <div class="v-modal-dialog-actions d-flex justify-content-center align-items-center mt-2"
                        v-if="disableMarkCompleteButton == true">
                        <button class="btn btn-des-small ml-2 mr-2" v-if="can_edit"
                            style="border: 1px solid transparent !important; background: #fff;width:180px" disabled>
                            <i class="icon icon-pencil text-muted"></i> Edit 
                        </button>
                        <button class="btn btn-des-small ml-2 mr-2"
                            style="position: relative;border: 1px solid transparent !important;width:180px" disabled>Mark as Complete
                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                    </div> -->
                    <div class="v-modal-dialog-actions d-flex justify-content-center align-items-center mt-2"
                    v-if="(( view_mode == 'view' && can_edit == false && can_mark_complete == false))">
                        <!-- v-if="(( view_mode == 'view' && can_edit == false && can_mark_complete == false ) || ( view_mode == 'edit' && can_edit == false && can_mark_complete == false ))"> -->
                        <button class="btn btn-des-small ml-2 mr-2" v-if="disableMarkCompleteButton == false"
                            style="color: #fff; background: #00448b; border: 1px solid #00448b;width:120px"
                            @click="hideCreateReminder">Close</button>
                        <button class="btn btn-des-small ml-2 mr-2" v-if="disableMarkCompleteButton == true"
                            style="color: #fff; background: #00448b; border: 1px solid #00448b;width:120px"
                            disabled>Close</button>
                        <button class="btn btn-des-small ml-2 mr-2" v-if="(view_mode == 'view' && reminder_status == 'pending' && disableMarkCompleteButton == false)"
                            style="color: #fff; background: #008a63; border: 1px solid #008a63;width:180px"
                            @click="UpdateStatusId">Mark as Complete
                        </button>
                        <button class="btn btn-des-small ml-2 mr-2" v-if="(view_mode == 'view' && reminder_status == 'pending' && disableMarkCompleteButton == true)"
                            style="position: relative;border: 1px solid transparent !important;width:180px" disabled>Mark as Complete
                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}
        </sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}
        </sweet-modal>
        <delete-type @hideDeleteType="hideDeleteType" v-if="delete_type" modal_name="deleteType" @updateStatus="MarkComplete"></delete-type>
        <update-type @hideUpdateType="hideUpdateType" :repeat_reminder="repeat_reminder" :old_reminder_data="old_reminder_data" v-if="update_status" modal_name="updateType" @updateType="SaveRemainder"></update-type>
    </div>
</template>
<script>
    import axios from "axios";
    import { SweetModal } from 'sweet-modal-vue';
    import convert from '../mixins/convert'
    import reminders from '../mixins/reminders'
    import products from '../mixins/products.js'
    import { debounce } from 'lodash';
    const DeleteType = () => import('./DeleteType')
    const UpdateType = () => import('./UpdateType')
    import { HalfCircleSpinner } from "epic-spinners";
    import { HollowDotsSpinner } from "epic-spinners";
    import moment from 'moment';
    import schedule from "../mixins/scheduleMeeting.js"
    export default ({
        props: ['modal_name', 'view_mode', 'mode_id', 'recurring_id', 'reminderType',"from_notification", "from_module", "stage_edit_mode", "lead_edit_stage", "lead_current_stage", "meeting_type"],
        mixins: [reminders, products, convert, schedule],
        data() {
            return {
                stringified_response: "",
                isUploadingInProgress: false,
                attachments: [],
                repeat_reminder_options: ["Does not Repeat","Daily","Weekly on Today's day","Monthly","Annually","Every Weekdays(Monday to Friday)", "Every Weekends(Saturday and Sunday)"],
                repeat_reminder: 'Does not Repeat',
                disableMarkCompleteButton: false,
                disableButtonAndDisplayLoader: false,
                ajaxCallInprogress: false,
                success_msg: '',
                warning_msg: '',
                reminder_type: '',
                reminder_name: '',
                assigned_to: [],
                due_date: '',
                due_time: '',
                time_format: [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ],
                currency: '',
                notes: '',
                followup_notes: '',
                event_notes: '',
                taskrem_notes: '',
                event_date: '',
                event_time: '',
                reminding_time: '',
                reminding_date: '',
                selected_event_products: [],
                selected_followup_products: [],
                selected_taskrem_products: [],
                selected_invitees: [],
                price: '',
                /* Employees Lazy Loading */
                member_visible: false,
                member_scrollable: false,
                members_loading: false,
                members_count: 0,
                temp_members_options: [],
                members_options: [],
                /* Products Lazy Loading */
                products_visible: false,
                product_scrollable: false,
                products_loading: false,
                product_count: 0,
                temp_products: [],
                products: [],
                reminder_status: '',
                store_invitees: [],
                remind_cycle: 'minute',
                remind_period: 10,
                temp_remind_cycle: 'Minutes',
                saveInProgress: false,
                origin: '',
                get_searched_members: [],
                decimal_check: /(?=[^\0])(?=^([0-9]+){0,1}(\.[0-9]{1,3}){0,1}$)/,
                isValidPrice: true,

                member_invitees_visible: false,
                member_invitees_scrollable: false,
                members_invitees_loading: false,
                members_invitees_count: 0,
                temp_members_invitees_options: 0,
                members_invitees_options: [],

                can_edit: false,
                can_mark_complete: false,
                reminder_creator: '',
                repeat_start_date: '',
                repeat_end_date: '',
                reminder_gap: '',
                reminder_number: 1,
                reminder_numbers: 0,
                repeatcheck:false,
                disable_repeat_end_date:"",
                disable_repeat_start_date: "",
                cycle_data: [],
                disable_repeat_day: false,
                cycle_options: ['Minute','Hour','Day', 'Month','Year'],
                repeat_difference_days: 0,
                repeat_difference_hours: "",
                set_reminder_options: [],
                delete_type: false,
                update_status: false,
                old_reminder_data: "",
                type_update: "",
                products_options: [],
                selected_field: '',
                products_scrollable: false,
                products_count: 0,
                meeting_details: [],
                meetingLoader: false,
                schedule_meeting: false,
                reminder_id: ""
            }
        },
        components: {
            SweetModal,
            HollowDotsSpinner,
            HalfCircleSpinner,
            DeleteType,
            UpdateType
        },
        methods: {
            async getMeetingData(){
                this.ajaxCallInprogress = true
                this.meetingLoader = true
                let params = {
                    id: this.recurring_id
                }
                let response = await this.getScheduleMeetingById(params)
                this.meeting_details = response.response
                this.reminder_type = 'Follow Up'
                this.reminder_name = this.meeting_details.meeting_title
                this.assigned_to = this.meeting_details.invitees
                this.followup_notes = this.meeting_details.description
                this.meetingLoader = false
                this.ajaxCallInprogress = false
            },
            limitProduct(count) {
                return `+ ${count} more`
            },
            resetData(type){
                this.selected_field = type
                this.employee_name_options = [];
                this.products_count = 0;
            },
            async searchProuctNameDebouncer(search){
                this.products_loading = true
                this.products_count = 0
                let params = {
                    skip: this.skip,
                    limit: 10,
                    search_key: search,
                    sort_key: "name",
                    sort_value: 1,
                    category_ids:[],
                    sub_category_ids:[],
                    product_type_ids:[],
                    product_ids:[],
                    brand_ids:[],
                    outlet_ids:[],
                    status:[],  
                    visibility:"Manufacturing"
                }
                let response = await this.ProductsList(params)
                this.products_options = response.response.result
                
                this.products_count = this.products_options.length
                this.products_loading = false
            },
            async reachedEndOfProductName(reached){
                if(reached){
                    if(this.products_scrollable == false){
                        this.products_loading = true
                        let response = await this.ProductsList({
                            skip: this.products_count,
                            limit: 10,
                            search_key: "",
                            sort_key: "name",
                            sort_value: 1,
                            category_ids:[],
                            sub_category_ids:[],
                            product_type_ids:[],
                            product_ids:[],
                            brand_ids:[],
                            outlet_ids:[],
                            status:[],  
                            visibility:"Manufacturing"
                        } )
                        let temp_products_options = response.response.result.length;
                        if(response.response.filter_data.skip == this.products_count){
                            if(temp_products_options > 0){
                                let tempfiles = response.response.result
                                // tempfiles.forEach(el => {
                                //     if(el[this.selected_field] != '' && el.hasOwnProperty(this.selected_field)){
                                //         this.products_options.push(el)
                                //     }
                                // })
                                // let uniqueArray = this.products_options.filter((value, index_dd) => {
                                //     const _value = value[this.selected_field];
                                //     return index_dd === this.products_options.findIndex(obj => {
                                //         return obj[this.selected_field] === _value;
                                //     });
                                // });
                                this.products_options = tempfiles
                                this.products_count += response.response.result.length;
                                this.products_loading = false
                            } else {
                                this.products_scrollable = true
                                this.products_loading = false
                            }
                            this.products_scrollable = false
                        }
                    }
                }
            },
            hideUpdateType(){
                this.update_status = false
            },
            updateType(){
                this.update_status = true
                setTimeout(() => {
                    this.$modal.show('updateType')
                }, 500);
            },
            UpdateStatusId(){
                // this.mode_id = id;
                // this.recurring_id = rec_id
                this.delete_type = true
                setTimeout(() => {
                    this.$modal.show('deleteType')
                }, 500);
            },
            hideDeleteType(){
                this.delete_type = false
                // this.mode_id = ''
                // this.recurring_id = ''
            },
            followupSetReminderOptions(){
                var date1 = new Date();
                var date2 = new Date(this.due_date);
                var Difference_In_Time = date2.getTime()  - date1.getTime();
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
                if(date1.getDate() == date2.getDate()){
                    if(this.remind_period == 1){
                        this.set_reminder_options = ['Hour', 'Minute']
                    } else {
                        this.set_reminder_options = ['Hours', 'Minutes']
                    }
                }else {
                    if(this.remind_period == 1){
                        this.set_reminder_options = ['Hour', 'Minute', 'Day']
                    } else {
                        this.set_reminder_options = ['Hours', 'Minutes','Days']
                    }
                }
                // if(Difference_In_Days > 30) {
                //     this.set_reminder_options = ['Minute','Hour' ,'Day', 'Month']
                // } if(Difference_In_Days > 365) {
                //     this.set_reminder_options = ['Minute','Hour' ,'Day', 'Month', 'Year']
                // }
            },
            // followupCalculateDifference(){
            //     var date1 = new Date(this.repeat_start_date);
            //     var date2 = new Date(this.repeat_end_date);
            //     var Difference_In_Time = date2.getTime()  - date1.getTime();
            //     var Difference_In_hours = Difference_In_Time / (1000 * 3600);
            //     this.repeat_difference_hours = Difference_In_hours
            //     var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
            //     this.repeat_difference_days = Difference_In_Days
            //     this.reminder_number = 1
            //     this.reminder_gap = ''
            // },
            //API call to check reminder already exist or not
            async checkReminderExist(data){
                try{
                    let entered_rem = data.target.value
                    let params = {
                        product_name: "CRM",
                        reminder_title: entered_rem
                    }
                    let response = await this.getReminderCheckAPI(params)
                } catch(error){
                    this.warning_msg = error
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
            //Deletes attachment file
            deleteAttachment(index) {
                this.attachments.splice(index, 1);
            },
            //Upload attachment
            uploadAttachment(newFile) {
                var input = newFile;
                if (input.file) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.file.name,
                        size: JSON.stringify(input.file.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    if (this.attachments.length >= 5) {
                        this.$toasted.global.error("you're not allowed to upload more than 5 attachments")
                    } else if (attachment.size > 5000 * 1000) {
                        this.$toasted.global.error("Attachment Size Cannot Exceed 5mb")
                    } else {
                        this.attachments.push(attachment);
                        this.getResumableURL(input.file, this.attachments[this.attachments.length - 1]);
                    }
                }
            },
            //Upload attachment to cloud and creates URL
            getResumableURL(file, attachment) {
                this.isUploadingInProgress = true;
                attachment.uploading = true;
                let data = {
                    file: attachment.name
                }
                data = new FormData()
                data.append('file', file)
                this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                    onUploadProgress: function (progressEvent) {
                        let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                        if (progress < 100) {
                            attachment.progress = progress;
                        }
                    }.bind(this)
                })
                .then(response => {
                    let resumable_url = response.data.url;
                    attachment.url = resumable_url;
                    attachment.progress = 100;
                    attachment.uploading = false;
                    this.isUploadingInProgress = false;
                    delete attachment['source'];
                })
                .catch(error => {
                })
            },
            //Method to calculate date difference
            calculateDifference(){
                var date1 = new Date(this.repeat_start_date);
                var date2 = new Date(this.repeat_end_date);
                var Difference_In_Time = date2.getTime()  - date1.getTime();
                var Difference_In_hours = Difference_In_Time / (1000 * 3600);
                this.repeat_difference_hours = Difference_In_hours
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
                this.repeat_difference_days = Difference_In_Days
                this.reminder_number = 1
                this.reminder_gap = ''
            },
            updateRepeatCycle(value){
                this.reminder_number = 1
            },
            checkDifference(event){
                if(this.reminder_gap == 'Hour'){
                    if(this.reminder_number > this.repeat_difference_hours){
                        this.reminder_number = 1
                    }else {
                        this.reminder_number = event.target.value
                    }
                }
                if(this.reminder_gap == 'Day'){
                    if(this.reminder_number > this.repeat_difference_days){
                        this.reminder_number = 1
                    }else {
                        this.reminder_number = event.target.value
                    }
                }
                if(this.reminder_gap == 'Month'){
                    let repeat_difference_month = this.repeat_difference_days / 30
                    if(this.reminder_number > repeat_difference_month){
                        this.reminder_number = 1
                    }else {
                        this.reminder_number = event.target.value
                    }
                }
                if(this.reminder_gap == 'Year'){
                    let repeat_difference_year = this.repeat_difference_days / 365
                    if(this.reminder_number > repeat_difference_year){
                        this.reminder_number = 1
                    }else {
                        this.reminder_number = event.target.value
                    }
                }
            },
            cycleOptions(){
                var date1 = new Date(this.repeat_start_date);
                var date2 = new Date(this.repeat_end_date);
                var Difference_In_Time = date2.getTime()  - date1.getTime();
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
                if(this.repeat_start_date == this.repeat_end_date){
                    this.cycle_options = ['Minute','Hour']
                } if(Difference_In_Days >= 1) {
                    this.cycle_options = ['Minute','Hour' ,'Day']
                } if(Difference_In_Days > 30) {
                    this.cycle_options = ['Minute','Hour' ,'Day', 'Month']
                } if(Difference_In_Days > 365) {
                    this.cycle_options = ['Minute','Hour' ,'Day', 'Month', 'Year']
                }
            },
            repeat(event) {
                if(event.target.checked){
                    this.repeatcheck = true;
                    this.reminder_number = '1'
                } else {
                    this.repeatcheck = false;
                    this.repeat_start_date = '',
                    this.repeat_end_date = '',
                    this.reminder_gap = '',
                    this.reminder_number = '0'
                }
            },
            clearRepeatEndDate(){
                this.repeat_end_date = '';
                let end_date = new Date(this.repeat_start_date)
                end_date.setDate(end_date.getDate())
                this.disable_repeat_end_date = end_date
            },
            checkNumberInRepeatCycle(){
                if(this.reminder_number == '0'){
                    this.reminder_number = '1'
                }
            },
            removeInvitees(value){
                this.selected_invitees.forEach((el,index)=>{
                    if(el.user_id == value.user_id){
                        this.selected_invitees.splice(index,1)
                    }
                })
            },
            //Validates time with current time to show future time
            checkDate(type){
                this.event_time = "";
                this.due_time = "";
                this.reminding_time = "";
                this.time_format = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
                if(type == 'event'){
                    var curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
                    if(this.event_date == curr_date){
                        var temp_start_time = ""
                        var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                        if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                            temp_start_time = curr_time.slice(0,3) + '00'
                        } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                            temp_start_time = curr_time.slice(0,3) + '15'
                        } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                            temp_start_time = curr_time.slice(0,3) + '30'
                        } else if(parseInt(curr_time.substring(3)) >= 45){
                            temp_start_time = curr_time.slice(0,3) + '45'
                        }
                        let indx = this.time_format.indexOf(temp_start_time)
                        this.time_format.splice(0,indx+1)
                    }
                } else if(type == 'task'){
                    var curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
                    if(this.due_date == curr_date){
                        var temp_start_time = ""
                        var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                        if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                            temp_start_time = curr_time.slice(0,3) + '00'
                        } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                            temp_start_time = curr_time.slice(0,3) + '15'
                        } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                            temp_start_time = curr_time.slice(0,3) + '30'
                        } else if(parseInt(curr_time.substring(3)) >= 45){
                            temp_start_time = curr_time.slice(0,3) + '45'
                        }
                        let indx = this.time_format.indexOf(temp_start_time)
                        this.time_format.splice(0,indx+1)
                    }
                } else if(type == 'follow_up'){
                    var curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
                    if(this.due_date == curr_date){
                        var temp_start_time = ""
                        var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                        if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                            temp_start_time = curr_time.slice(0,3) + '00'
                        } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                            temp_start_time = curr_time.slice(0,3) + '15'
                        } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                            temp_start_time = curr_time.slice(0,3) + '30'
                        } else if(parseInt(curr_time.substring(3)) >= 45){
                            temp_start_time = curr_time.slice(0,3) + '45'
                        }
                        let indx = this.time_format.indexOf(temp_start_time)
                        this.time_format.splice(0,indx+1)
                    }
                }
                this.repeat_start_date = '';
                let startDate = new Date(this.due_date)
                startDate.setDate(startDate.getDate() + 1)
                this.disable_repeat_start_date = startDate
            },
            //API call ti get members list
            async fetchMembersDataById(key) {
                this.members_loading = true
                let params = {
                    skip: 0,
                    search_key: key,
                    company_id: this.loggedInUser.company_id,
                }
                let response = await this.getMembersData(params)
                this.get_searched_members = response.response;
                this.get_searched_members.forEach(x => {
                    this.store_invitees.push(x)
                })
                // this.members_count += response.response.length;
                // this.members_loading = false
            },
            //Method convers time format
            convertTime12to24(time12h){
                const [time, modifier] = time12h.split(' ');
                let [hours, minutes] = time.split(':');
                if (hours === '12') {
                    hours = '00';
                }
                if (modifier === 'PM') {
                    hours = parseInt(hours, 10) + 12;
                }
                return `${hours}:${minutes}`;
            },
            //Method to check minutes hours and days
            checkNumber() {
                if(this.remind_period <= 1){
                    if(this.temp_remind_cycle == 'Minutes'){
                        this.temp_remind_cycle = 'Minute'
                    } else if(this.temp_remind_cycle == 'Hours'){
                        this.temp_remind_cycle = 'Hour'
                    } else if(this.temp_remind_cycle == 'Days'){
                        this.temp_remind_cycle = 'Day'
                    }
                } else {
                    if(this.temp_remind_cycle == 'Minute'){
                        this.temp_remind_cycle = 'Minutes'
                    } else if(this.temp_remind_cycle == 'Hour'){
                        this.temp_remind_cycle = 'Hours'
                    } else if(this.temp_remind_cycle == 'Day'){
                        this.temp_remind_cycle = 'Days'
                    }
                }
                if (this.remind_period == '0') {
                    this.remind_period = 1
                }
            },
            changeRemindPeriod(){
               if(this.temp_remind_cycle == 'Minutes' || this.temp_remind_cycle == 'Minute'){
                this.remind_cycle = 'minute'
               } else if(this.temp_remind_cycle == 'Hours' || this.temp_remind_cycle == 'Hour'){
                this.remind_cycle = 'hour'
               } else if(this.temp_remind_cycle == 'Days' || this.temp_remind_cycle == 'Day'){
                this.remind_cycle = 'day'
               }
            },
            hideCreateReminder() {
                this.$emit("hideCreateReminder", false)
            },
            //API call to search members
            async searchMembersDataDebouncer(key) {
                this.members_loading = true
                let params = {
                    skip: 0,
                    search_key: key,
                    company_id: this.loggedInUser.company_id,
                }
                let response = await this.getMembersData(params)
                this.members_options = response.response;
                // this.members_options.forEach(x => {
                //     this.store_invitees.push(x)
                // })
                this.members_count += response.response.length;
                this.members_loading = false
            },
            //API call to fetch employee data
            async fetchMembersData(key) {
                this.members_loading = true
                let params = {
                    skip: 0,
                    search_key: key,
                    company_id: this.loggedInUser.company_id,
                }
                let response = await this.getMembersData(params)
                this.members_options = response.response;
                this.members_options.forEach(x => {
                    this.store_invitees.push(x)
                })
                this.members_count += response.response.length;
                // this.members_loading = false
            },
            //Lazy loading for employee API call
            async reachedEndOfEmployees(reached) {
                this.member_visible = reached
                if (reached) {
                    if (this.member_scrollable == false) {
                        this.members_loading = true
                        let params = {
                            skip: this.members_count,
                            company_id: this.loggedInUser.company_id,
                        }
                        let response = await this.getMembersData(params)
                        this.temp_members_options = response.response.length;
                        if (response.skip == this.members_count) {
                            if (this.temp_members_options > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.members_options.push(el);
                                });
                                this.members_count += response.response.length;
                                this.members_loading = false
                            } else {
                                this.member_scrollable = true
                                this.members_loading = false
                            }
                        }
                        this.members_loading = false
                    }
                }
            },
            //Lazy loading for invitees API call
            async reachedEndOfInvitedEmployees(reached) {
                this.member_invitees_visible = reached
                if (reached) {
                    if (this.member_invitees_scrollable == false) {
                        this.members_invitees_loading = true
                        let params = {
                            skip: this.members_invitees_count,
                            company_id: this.loggedInUser.company_id,
                            exclude: [this.loggedInUser.user_id]
                        }
                        let response = await this.getMembersData(params)
                        this.temp_members_invitees_options = response.response.length;
                        if (response.skip == this.members_invitees_count) {
                            if (this.temp_members_invitees_options > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.members_invitees_options.push(el);
                                });
                                this.members_invitees_count += response.response.length;
                                this.members_invitees_loading = false
                            } else {
                                this.member_invitees_scrollable = true
                                this.members_invitees_loading = false
                            }
                        }
                        this.members_invitees_loading = false
                    }
                }
            },
            //API call for invitees data
            async searchInvitedMembersDataDebouncer(key) {
                this.members_invitees_loading = true
                let params = {
                    skip: 0,
                    search_key: key,
                    company_id: this.loggedInUser.company_id,
                    exclude: [this.loggedInUser.id]
                }
                let response = await this.getMembersData(params)
                this.members_invitees_options = response.response;
                this.members_invitees_count += response.response.length;
                this.members_invitees_loading = false
            },
            //Lazy loading for products API call
            async reachedEndOfProducts(reached) {
                this.products_visible = reached
                if (reached) {
                    if (this.product_scrollable == false) {
                        this.products_loading = true
                        let response = await this.ListProducts({
                            skip: this.product_count,
                            limit: 10,
                            search_key: "",
                            sort_value: 1,
                            sort_key: "id",
                        })
                        this.temp_products = response.response.length;
                        if (response.skip == this.product_count) {
                            if (this.temp_products > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.products.push(el);
                                    this.products = this.products.filter(x => {
                                        if (x.name) {
                                            return x
                                        }
                                    })
                                });
                                this.product_count += response.response.length;
                                this.products_loading = false
                            } else {
                                this.product_scrollable = true
                                this.products_loading = false
                            }
                        }
                        this.products_loading = false
                    }
                }
            },
            //API call to search product
            async searchProductDebouncer(search_key) {
                this.products_loading = true
                let response = await this.ListProducts({
                    skip: 0,
                    limit: 10,
                    search_key: search_key,
                    sort_value: 1,
                    sort_key: "id",
                })
                this.products = response.response
                this.product_count = this.temp_products.length
                this.products_loading = false
                this.product_scrollable = true
            },
            //API call to save new reminder and edited reminder
            async SaveRemainder($event) {
                this.$validator.validateAll().then(async result => {
                    if (result) {
                        let temp_attachments = []
                        let temp_invitees = []
                        let temp_products = []
                        let params = {}
                        let temp_repeat_cycle_type = ""
                        if(this.repeat_reminder == "Does not Repeat"){
                            temp_repeat_cycle_type = "never"
                        } else if(this.repeat_reminder == "Daily"){
                            temp_repeat_cycle_type = "daily"
                        } else if(this.repeat_reminder == "Weekly on Today's day"){
                            temp_repeat_cycle_type = "weekly"
                        } else if(this.repeat_reminder == "Monthly"){
                            temp_repeat_cycle_type = "monthly"
                        } else if(this.repeat_reminder == "Annually"){
                            temp_repeat_cycle_type = "annually"
                        } else if(this.repeat_reminder == "Every Weekdays(Monday to Friday)"){
                            temp_repeat_cycle_type = "weekdays"
                        } else if(this.repeat_reminder == "Every Weekends(Saturday and Sunday)"){
                            temp_repeat_cycle_type = "weekends"
                        }
                        // this.products_options.forEach((el_product, el_product_index) => {
                        //     temp_products.push({
                        //         id: [...new Set(this.el_product.map(x => x._id))],
                        //         name: [...new Set(this.el_product.map(x => x.name))]
                        //     })
                        // })
                        this.selected_event_products.forEach((el_product, el_product_index) => {
                            temp_products.push({
                                id: el_product._id ? el_product._id : el_product.id,
                                name: el_product.name
                            })
                        })
                        this.attachments.forEach((el_att, el_att_index) => {
                            temp_attachments.push({
                                url: el_att.url,
                                name: el_att.name,
                                size: el_att.size
                            })
                        })
                        this.assigned_to.forEach((el, index) => {
                            temp_invitees.push({
                                email: el.email,
                                id: el.user_id ? el.user_id : el.id,
                                full_name: el.full_name 
                            })
                        })
                        this.disableButtonAndDisplayLoader = true;
                        this.saveInProgress = true
                        if (this.view_mode == 'create' && this.schedule_meeting == true) {
                            if (this.from_module == 'contact') {
                                params = {
                                    product_name: "CRM",
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    origin: 'contacts',
                                    reference_id: this.recurring_id,
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products
                                }
                            } else if (this.from_module == 'customer') {
                                params = {
                                    product_name: "CRM",
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    origin: 'customers',
                                    reference_id: this.recurring_id,
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products
                                }
                            } else if (this.from_module == 'leads') {
                                params = {
                                    product_name: "CRM",
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    origin: 'leads',
                                    reference_id: this.recurring_id,
                                    stage_name: this.stage_edit_mode == 'off' ? this.lead_current_stage : this.lead_edit_stage,
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products
                                }
                            } else {
                                params = {
                                    product_name: "CRM",
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    origin: 'reminders',
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products
                                }
                            }
                            try 
                            {
                                let response = await this.createToolRemindersData(params)
                                if(response.status_id == 1 && this.schedule_meeting == true){
                                    this.reminder_id = response.reminder_id
                                    this.scheduleMeeting();
                                }
                                this.success_msg = response.message
                                this.$refs.success_modal.open();
                                setTimeout(() => {
                                    this.disableButtonAndDisplayLoader = false;
                                    this.$refs.success_modal.close();
                                    this.$emit("hideCreateReminderSave", true)
                                }, 2000);
                            } catch (err) {
                                this.saveInProgress = false
                                this.warning_msg = err
                                this.$refs.warning_modal.open();
                                setTimeout(() => {
                                    this.disableButtonAndDisplayLoader = false;
                                    this.$refs.warning_modal.close();
                                }, 2000);
                            }
                        }else if (this.view_mode == 'create' && this.schedule_meeting == false) {
                            if (this.from_module == 'contact') {
                                params = {
                                    product_name: "CRM",
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    origin: 'contacts',
                                    reference_id: this.$route.params.id,
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products
                                }
                            } else if (this.from_module == 'customer') {
                                params = {
                                    product_name: "CRM",
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    origin: 'customers',
                                    reference_id: this.$route.params.id,
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products
                                }
                            } else if (this.from_module == 'leads') {
                                params = {
                                    product_name: "CRM",
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    origin: 'leads',
                                    reference_id: this.$route.params.id,
                                    stage_name: this.stage_edit_mode == 'off' ? this.lead_current_stage : this.lead_edit_stage,
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products
                                }
                            } else {
                                params = {
                                    product_name: "CRM",
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    origin: 'reminders',
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products
                                }
                            }
                            try 
                            {
                                let response = await this.createToolRemindersData(params)
                                if(response.status_id == 1 && this.schedule_meeting == true){
                                    this.reminder_id = response.reminder_id
                                    this.scheduleMeeting();
                                }
                               
                                // if (this.reminder_type == 'Event') {
                                //     var response = await this.createRemindersData(this
                                //         .EventJSONData)
                                // } else if (this.reminder_type == 'Follow Up') {
                                //     var response = await this.createRemindersData(this
                                //         .FollowUpJSONData)
                                // } else {
                                //     var response = await this.createRemindersData(this
                                //         .TaskRemJSONData)
                                // }
                                this.success_msg = response.message
                                this.$refs.success_modal.open();
                                setTimeout(() => {
                                    this.disableButtonAndDisplayLoader = false;
                                    this.$refs.success_modal.close();
                                    this.$emit("hideCreateReminderSave", true)
                                }, 2000);
                            } catch (err) {
                                this.saveInProgress = false
                                this.warning_msg = err
                                this.$refs.warning_modal.open();
                                setTimeout(() => {
                                    this.disableButtonAndDisplayLoader = false;
                                    this.$refs.warning_modal.close();
                                }, 2000);
                            }
                        } else if (this.view_mode == 'edit') {
                            if(this.old_reminder_data == 'never'){
                                if(temp_repeat_cycle_type != "never"){
                                    this.type_update = 'all'
                                }else {
                                    this.type_update = 'none'
                                }
                            }else if(this.repeat_reminder != 'Does not Repeat' && this.old_reminder_data != 'never'){
                                this.type_update = $event
                            }else{
                                this.type_update = 'none'
                            }
                            if (this.from_module == 'contact') {
                                params = {
                                    product_name: "CRM",
                                    _id: this.mode_id,
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    reference_id: this.recurring_id,
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products,
                                    update_type: this.type_update,
                                    recurring_id: this.recurring_id
                                }
                            } else if (this.from_module == 'customer') {
                                params = {
                                    product_name: "CRM",
                                    _id: this.mode_id,
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    reference_id: this.$route.params.id,
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products,
                                    update_type: this.type_update,
                                    recurring_id: this.recurring_id
                                }
                            } else if (this.from_module == 'leads') { 
                                params = {
                                    product_name: "CRM",
                                    _id: this.mode_id,
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    reference_id: this.$route.params.id,
                                    stage_name: this.stage_edit_mode == 'off' ? this.lead_current_stage : this.lead_edit_stage,
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products,
                                    update_type: this.type_update,
                                    recurring_id: this.recurring_id
                                }
                            } else {
                                params = {
                                    product_name: "CRM",
                                    _id: this.mode_id,
                                    reminder_title: this.reminder_name,
                                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                                    remind_date: this.due_date,
                                    remind_time: this.due_time,
                                    repeat: temp_repeat_cycle_type == "never" ? false : true,
                                    repeat_details: {
                                        repeat_cycle_type: temp_repeat_cycle_type
                                    },
                                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                                    remind_cycle_period: this.remind_period,
                                    notes: this.followup_notes,
                                    attachments: temp_attachments,
                                    invitees: temp_invitees,
                                    products: temp_products,
                                    update_type: this.type_update,
                                    recurring_id: this.recurring_id
                                }
                            }
                            try {
                                let response = await this.PatchToolRemindersById(params)
                                // if (this.reminder_type == 'Event') {
                                //     var response = await this.PatchRemindersById(this.mode_id, this
                                //         .EventJSONData)
                                // } else if (this.reminder_type == 'Follow Up') {
                                //     var response = await this.PatchRemindersById(this.mode_id, this
                                //         .FollowUpJSONData)
                                // } else {
                                //     var response = await this.PatchRemindersById(this.mode_id, this
                                //         .TaskRemJSONData)
                                // }
                                this.success_msg = response.message
                                this.$refs.success_modal.open();
                                setTimeout(() => {
                                    this.disableButtonAndDisplayLoader = false;
                                    this.$refs.success_modal.close();
                                    this.$emit("hideCreateReminderSave", true)
                                }, 2000);
                            } catch (err) {
                                this.saveInProgress = false
                                this.warning_msg = err
                                this.$refs.warning_modal.open();
                                this.disableButtonAndDisplayLoader = false;
                                setTimeout(() => {
                                    this.$refs.warning_modal.close();
                                }, 2000);
                            }
                        }
                    }
                    // else {
                    //     this.saveInProgress = false
                    //     this.warning_msg = 'Please Fill All The Required Fields'
                    //     this.$refs.warning_modal.open();
                    //     setTimeout(() => {
                    //         this.$refs.warning_modal.close();
                    //     }, 2000);
                    // }
                })
            },
            async scheduleMeeting(){
                let params = {
                    "product_name": "CRM",
                    "_id": this.recurring_id,
                    "call_report_id": "",
                    "call_report" : false, 
                    "reminder_id": this.reminder_id
                }
                let res = await this.MeetingCallreports(params);
            },
            //API call to complete pending reminders
            async MarkComplete($event) {
                this.disableMarkCompleteButton = true;
                try {
                    let params ={
                        product_name: "CRM",
                        id: this.mode_id,
                        status: "completed",
                        update_type: $event,
                        recurrence_id: this.recurring_id
                    }
                    let response = await this.PatchRemindersById(params)
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.disableMarkCompleteButton = false;
                        this.$refs.success_modal.close();
                        this.$emit("hideCreateReminderSave", true)
                    }, 2000);
                } catch (err) {
                    this.warning_msg = err
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.disableMarkCompleteButton = false;
                        this.$refs.warning_modal.close();
                    }, 2000);
                }
            },
            // async getContactReminders() {
            //     this.ajaxCallInprogress = true;
            //     let response = await this.GetContactReminderById(this.mode_id)
            //     let rem_type = response.response.reminder_type
            //     this.reminder_name = response.response.reminder_title
            //     this.reminder_status = response.response.status
            //     this.origin = response.response.origin
            //     this.due_date = response.response.remind_date
            //     this.due_time = response.response.remind_time
            //     this.remind_period = response.response.remind_cycle_period
            //     this.remind_cycle = response.response.remind_cycle_type
            //     // user_id of the creator
            //     this.reminder_creator = response.response.created_by
            //     this.repeatcheck = response.response.repeat
            //     this.repeat_start_date = response.response.repeat_start_date
            //     this.repeat_end_date = response.response.repeat_end_date
            //     this.reminder_gap  = response.response.repeat_cycle_type == null ? "" : response.response.repeat_cycle_type
            //     this.reminder_number = response.response.repeat_cycle_period
            //     this.followup_notes = response.response.extra_fields.notes
            //     // Show/Hide the Edit button and Mark as complete buttons
            //     // this.can_edit= response.response.is_edit
            //     // this.can_mark_complete= response.response.is_mark_complete
            //     this.ajaxCallInprogress = false;
            //     if(this.reminder_gap == 'minute'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Minute'
            //         } 
            //     } else if(this.reminder_gap == 'hour'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Hour'
            //         } 
            //     } else if(this.reminder_gap == 'day'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Day'
            //         } 
            //     } else if(this.reminder_gap == 'month'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Month'
            //         } 
            //     } else if(this.reminder_gap == 'year'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Year'
            //         } 
            //     } 
            //     if(this.remind_cycle == 'minute'){
            //         if(response.response.remind_period < 2){
            //             this.temp_remind_cycle = 'Minute'
            //         } else {
            //             this.temp_remind_cycle = 'Minutes'
            //         }
            //     } else if(this.remind_cycle == 'hour'){
            //         if(response.response.remind_period < 2){
            //             this.temp_remind_cycle = 'Hour'
            //         } else {
            //             this.temp_remind_cycle = 'Hours'
            //         }
            //     } else if(this.remind_cycle == 'day'){
            //         if(response.response.remind_period < 2){
            //             this.temp_remind_cycle = 'Day'
            //         } else {
            //             this.temp_remind_cycle = 'Days'
            //         }
            //     }
            //     if (rem_type == 'event') {
            //         this.reminder_type = 'Event'
            //         this.event_date = response.response.start_date
            //         this.event_time = response.response.start_time
            //         this.selected_invitees = response.response.invitees
            //         response.response.invitees.forEach((x) => {
            //             this.fetchMembersDataById(x.email)
            //         })
            //         setTimeout(() => {
            //             this.selected_invitees = []
            //             this.store_invitees.forEach(x => {
            //                 this.selected_invitees.push(x)
            //             })
            //             this.members_loading = false
            //         }, 3000);
            //         this.selected_event_products = response.response.products
            //         this.event_notes = response.response.notes
            //     } else if (rem_type == 'task') {
            //         this.reminder_type = 'Task'
            //         this.assigned_to = {
            //             user_id: response.response.assigned_to,
            //             full_name: response.response.assigned_to_name
            //         }
            //         if(this.from_notification){
            //             if(this.loggedInUser.user_id != this.assigned_to.user_id){
            //                 this.reminderType = 'Invitations'
            //             }
            //         }
            //         let temp_selected_followup_products = []
            //         let temp_products = response.response.products
            //         temp_products.forEach((el_product, el_product_index) => {
            //             temp_selected_followup_products.push({
            //                 id: el_product.product_id,
            //                 name: el_product.product_name
            //             })
            //         })
            //         this.selected_followup_products = temp_selected_followup_products
            //         this.taskrem_notes = response.response.extra_fields.notes
            //     } else if (rem_type == 'follow_up') {
            //         this.reminder_type = 'Follow Up'
            //         this.assigned_to = {
            //             user_id: response.response.assigned_to,
            //             full_name: response.response.assigned_to_name
            //         }
            //         if(this.from_notification){
            //             if(this.loggedInUser.user_id != this.assigned_to.user_id){
            //                 this.reminderType = 'Invitations'
            //             }
            //         }
            //         // this.price = response.response.price
            //         // this.followup_notes = response.response.notes
            //         let temp_selected_followup_products = []
            //         let temp_products = response.response.products
            //         temp_products.forEach((el_product, el_product_index) => {
            //             temp_selected_followup_products.push({
            //                 id: el_product.product_id,
            //                 name: el_product.product_name
            //             })
            //         })
            //         this.selected_followup_products = temp_selected_followup_products
            //     }
            //     var curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
            //     if(this.due_date == curr_date){
            //         var temp_start_time = ""
            //         var curr_time = moment(new Date().toUTCString()).format("HH:mm");
            //         if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
            //             temp_start_time = curr_time.slice(0,3) + '00'
            //         } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
            //             temp_start_time = curr_time.slice(0,3) + '15'
            //         } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
            //             temp_start_time = curr_time.slice(0,3) + '30'
            //         } else if(parseInt(curr_time.substring(3)) >= 45){
            //             temp_start_time = curr_time.slice(0,3) + '45'
            //         }
            //         let indx = this.time_format.indexOf(temp_start_time)
            //         this.time_format.splice(0,indx+1)
            //     }
            //     let startDate = new Date(this.due_date)
            //     startDate.setDate(startDate.getDate() + 1)
            //     this.disable_repeat_start_date = startDate
            //     var date1 = new Date(this.repeat_start_date);
            //     var date2 = new Date(this.repeat_end_date);
            //     var Difference_In_Time = date2.getTime()  - date1.getTime();
            //     var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
            //     if(this.repeat_start_date == this.repeat_end_date){
            //         this.cycle_options = ['Minute','Hour']
            //     } if(Difference_In_Days >= 1) {
            //         this.cycle_options = ['Minute','Hour' ,'Day']
            //     } if(Difference_In_Days > 30) {
            //         this.cycle_options = ['Minute','Hour' ,'Day', 'Month']
            //     } if(Difference_In_Days > 365) {
            //         this.cycle_options = ['Minute','Hour' ,'Day', 'Month', 'Year']
            //     }
            //     this.ajaxCallInprogress = false;
            // },
            // async getCustomerReminders() {
            //     this.ajaxCallInprogress = true;
            //     let response = await this.GetCustomerReminderById(this.mode_id)
            //     let rem_type = response.response.reminder_type
            //     this.reminder_name = response.response.reminder_title
            //     this.reminder_status = response.response.status
            //     this.origin = response.response.origin
            //     this.due_date = response.response.remind_date
            //     this.due_time = response.response.remind_time
            //     this.remind_period = response.response.remind_cycle_period
            //     this.remind_cycle = response.response.remind_cycle_type
            //     // user_id of the creator
            //     this.reminder_creator = response.response.created_by
            //     this.repeatcheck = response.response.repeat
            //     this.repeat_start_date = response.response.repeat_start_date
            //     this.repeat_end_date = response.response.repeat_end_date
            //     this.reminder_gap  = response.response.repeat_cycle_type == null ? '' : response.response.repeat_cycle_type
            //     this.reminder_number = response.response.repeat_cycle_period
            //     this.followup_notes = response.response.extra_fields.notes
            //     // Show/Hide the Edit button and Mark as complete buttons
            //     // this.can_edit= response.response.is_edit
            //     // this.can_mark_complete= response.response.is_mark_complete
            //     this.ajaxCallInprogress = false;
            //     if(this.reminder_gap == 'minute'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Minute'
            //         } 
            //     } else if(this.reminder_gap == 'hour'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Hour'
            //         } 
            //     } else if(this.reminder_gap == 'day'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Day'
            //         } 
            //     } else if(this.reminder_gap == 'month'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Month'
            //         } 
            //     } else if(this.reminder_gap == 'year'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Year'
            //         } 
            //     } 
            //     if(this.remind_cycle == 'minute'){
            //         if(response.response.remind_period < 2){
            //             this.temp_remind_cycle = 'Minute'
            //         } else {
            //             this.temp_remind_cycle = 'Minutes'
            //         }
            //     } else if(this.remind_cycle == 'hour'){
            //         if(response.response.remind_period < 2){
            //             this.temp_remind_cycle = 'Hour'
            //         } else {
            //             this.temp_remind_cycle = 'Hours'
            //         }
            //     } else if(this.remind_cycle == 'day'){
            //         if(response.response.remind_period < 2){
            //             this.temp_remind_cycle = 'Day'
            //         } else {
            //             this.temp_remind_cycle = 'Days'
            //         }
            //     }
            //     if (rem_type == 'event') {
            //         this.reminder_type = 'Event'
            //         this.event_date = response.response.start_date
            //         this.event_time = response.response.start_time
            //         this.selected_invitees = response.response.invitees
            //         response.response.invitees.forEach((x) => {
            //             this.fetchMembersDataById(x.email)
            //         })
            //         setTimeout(() => {
            //             this.selected_invitees = []
            //             this.store_invitees.forEach(x => {
            //                 this.selected_invitees.push(x)
            //             })
            //             this.members_loading = false
            //         }, 3000);
            //         this.selected_event_products = response.response.products
            //         this.event_notes = response.response.notes
            //     } else if (rem_type == 'task') {
            //         this.reminder_type = 'Task'
            //         this.assigned_to = {
            //             user_id: response.response.assigned_to,
            //             full_name: response.response.assigned_to_name
            //         }
            //         if(this.from_notification){
            //             if(this.loggedInUser.user_id != this.assigned_to.user_id){
            //                 this.reminderType = 'Invitations'
            //             }
            //         }
            //         let temp_selected_followup_products = []
            //         let temp_products = response.response.products
            //         temp_products.forEach((el_product, el_product_index) => {
            //             temp_selected_followup_products.push({
            //                 id: el_product.product_id,
            //                 name: el_product.product_name
            //             })
            //         })
            //         this.selected_followup_products = temp_selected_followup_products
            //         this.taskrem_notes = response.response.extra_fields.notes
            //     } else if (rem_type == 'follow_up') {
            //         this.reminder_type = 'Follow Up'
            //         this.assigned_to = {
            //             user_id: response.response.assigned_to,
            //             full_name: response.response.assigned_to_name
            //         }
            //         if(this.from_notification){
            //             if(this.loggedInUser.user_id != this.assigned_to.user_id){
            //                 this.reminderType = 'Invitations'
            //             }
            //         }
            //         // this.price = response.response.price
            //         // this.followup_notes = response.response.notes
            //         let temp_selected_followup_products = []
            //         let temp_products = response.response.products
            //         temp_products.forEach((el_product, el_product_index) => {
            //             temp_selected_followup_products.push({
            //                 id: el_product.product_id,
            //                 name: el_product.product_name
            //             })
            //         })
            //         this.selected_followup_products = temp_selected_followup_products
            //     }
            //     var curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
            //     if(this.due_date == curr_date){
            //         var temp_start_time = ""
            //         var curr_time = moment(new Date().toUTCString()).format("HH:mm");
            //         if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
            //             temp_start_time = curr_time.slice(0,3) + '00'
            //         } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
            //             temp_start_time = curr_time.slice(0,3) + '15'
            //         } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
            //             temp_start_time = curr_time.slice(0,3) + '30'
            //         } else if(parseInt(curr_time.substring(3)) >= 45){
            //             temp_start_time = curr_time.slice(0,3) + '45'
            //         }
            //         let indx = this.time_format.indexOf(temp_start_time)
            //         this.time_format.splice(0,indx+1)
            //     }
            //     let startDate = new Date(this.due_date)
            //     startDate.setDate(startDate.getDate() + 1)
            //     this.disable_repeat_start_date = startDate
            //     var date1 = new Date(this.repeat_start_date);
            //     var date2 = new Date(this.repeat_end_date);
            //     var Difference_In_Time = date2.getTime()  - date1.getTime();
            //     var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
            //     if(this.repeat_start_date == this.repeat_end_date){
            //         this.cycle_options = ['Minute','Hour']
            //     } if(Difference_In_Days >= 1) {
            //         this.cycle_options = ['Minute','Hour' ,'Day']
            //     } if(Difference_In_Days > 30) {
            //         this.cycle_options = ['Minute','Hour' ,'Day', 'Month']
            //     } if(Difference_In_Days > 365) {
            //         this.cycle_options = ['Minute','Hour' ,'Day', 'Month', 'Year']
            //     }
            //     this.ajaxCallInprogress = false;
            // },
            // async getLeadsReminders() {
            //     this.ajaxCallInprogress = true;
            //     let response = await this.GetLeadsReminderById(this.mode_id)
            //     let rem_type = response.response.reminder_type
            //     this.reminder_name = response.response.reminder_title
            //     this.reminder_status = response.response.status
            //     this.origin = response.response.origin
            //     this.due_date = response.response.remind_date
            //     this.due_time = response.response.remind_time
            //     this.remind_period = response.response.remind_cycle_period
            //     this.remind_cycle = response.response.remind_cycle_type
            //     // user_id of the creator
            //     this.reminder_creator = response.response.created_by
            //     this.repeatcheck = response.response.repeat
            //     this.repeat_start_date = response.response.repeat_start_date
            //     this.repeat_end_date = response.response.repeat_end_date
            //     this.reminder_gap  = response.response.repeat_cycle_type == null ? "" : response.response.repeat_cycle_type
            //     this.reminder_number = response.response.repeat_cycle_period
            //     this.followup_notes = response.response.extra_fields.notes
            //     // Show/Hide the Edit button and Mark as complete buttons
            //     // this.can_edit= response.response.is_edit
            //     // this.can_mark_complete= response.response.is_mark_complete
            //     this.ajaxCallInprogress = false;
            //     if(this.reminder_gap == 'minute'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Minute'
            //         } 
            //     } else if(this.reminder_gap == 'hour'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Hour'
            //         } 
            //     } else if(this.reminder_gap == 'day'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Day'
            //         } 
            //     } else if(this.reminder_gap == 'month'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Month'
            //         } 
            //     } else if(this.reminder_gap == 'year'){
            //         if(response.response.repeat_cycle_type){
            //             this.reminder_gap = 'Year'
            //         } 
            //     } 
            //     if(this.remind_cycle == 'minute'){
            //         if(response.response.remind_period < 2){
            //             this.temp_remind_cycle = 'Minute'
            //         } else {
            //             this.temp_remind_cycle = 'Minutes'
            //         }
            //     } else if(this.remind_cycle == 'hour'){
            //         if(response.response.remind_period < 2){
            //             this.temp_remind_cycle = 'Hour'
            //         } else {
            //             this.temp_remind_cycle = 'Hours'
            //         }
            //     } else if(this.remind_cycle == 'day'){
            //         if(response.response.remind_period < 2){
            //             this.temp_remind_cycle = 'Day'
            //         } else {
            //             this.temp_remind_cycle = 'Days'
            //         }
            //     }
            //     if (rem_type == 'event') {
            //         this.reminder_type = 'Event'
            //         this.event_date = response.response.start_date
            //         this.event_time = response.response.start_time
            //         this.selected_invitees = response.response.invitees
            //         response.response.invitees.forEach((x) => {
            //             this.fetchMembersDataById(x.email)
            //         })
            //         setTimeout(() => {
            //             this.selected_invitees = []
            //             this.store_invitees.forEach(x => {
            //                 this.selected_invitees.push(x)
            //             })
            //             this.members_loading = false
            //         }, 3000);
            //         this.selected_event_products = response.response.products
            //         this.event_notes = response.response.notes
            //     } else if (rem_type == 'task') {
            //         this.reminder_type = 'Task'
            //         this.assigned_to = {
            //             user_id: response.response.assigned_to,
            //             full_name: response.response.assigned_to_name
            //         }
            //         if(this.from_notification){
            //             if(this.loggedInUser.user_id != this.assigned_to.user_id){
            //                 this.reminderType = 'Invitations'
            //             }
            //         }
            //         let temp_selected_followup_products = []
            //         let temp_products = response.response.products
            //         temp_products.forEach((el_product, el_product_index) => {
            //             temp_selected_followup_products.push({
            //                 id: el_product.id,
            //                 name: el_product.name
            //             })
            //         })
            //         this.selected_followup_products = temp_selected_followup_products
            //         this.taskrem_notes = response.response.extra_fields.notes
            //     } else if (rem_type == 'follow_up') {
            //         this.reminder_type = 'Follow Up'
            //         this.assigned_to = {
            //             user_id: response.response.assigned_to,
            //             full_name: response.response.assigned_to_name
            //         }
            //         if(this.from_notification){
            //             if(this.loggedInUser.user_id != this.assigned_to.user_id){
            //                 this.reminderType = 'Invitations'
            //             }
            //         }
            //         // this.price = response.response.price
            //         // this.followup_notes = response.response.notes
            //         let temp_selected_followup_products = []
            //         let temp_products = response.response.products
            //         temp_products.forEach((el_product, el_product_index) => {
            //             temp_selected_followup_products.push({
            //                 id: el_product.id,
            //                 name: el_product.name
            //             })
            //         })
            //         this.selected_followup_products = temp_selected_followup_products
            //     }
            //     var curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
            //     if(this.due_date == curr_date){
            //         var temp_start_time = ""
            //         var curr_time = moment(new Date().toUTCString()).format("HH:mm");
            //         if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
            //             temp_start_time = curr_time.slice(0,3) + '00'
            //         } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
            //             temp_start_time = curr_time.slice(0,3) + '15'
            //         } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
            //             temp_start_time = curr_time.slice(0,3) + '30'
            //         } else if(parseInt(curr_time.substring(3)) >= 45){
            //             temp_start_time = curr_time.slice(0,3) + '45'
            //         }
            //         let indx = this.time_format.indexOf(temp_start_time)
            //         this.time_format.splice(0,indx+1)
            //     }
            //     let startDate = new Date(this.due_date)
            //     startDate.setDate(startDate.getDate() + 1)
            //     this.disable_repeat_start_date = startDate
            //     var date1 = new Date(this.repeat_start_date);
            //     var date2 = new Date(this.repeat_end_date);
            //     var Difference_In_Time = date2.getTime()  - date1.getTime();
            //     var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
            //     if(this.repeat_start_date == this.repeat_end_date){
            //         this.cycle_options = ['Minute','Hour']
            //     } if(Difference_In_Days >= 1) {
            //         this.cycle_options = ['Minute','Hour' ,'Day']
            //     } if(Difference_In_Days > 30) {
            //         this.cycle_options = ['Minute','Hour' ,'Day', 'Month']
            //     } if(Difference_In_Days > 365) {
            //         this.cycle_options = ['Minute','Hour' ,'Day', 'Month', 'Year']
            //     }
            //     this.ajaxCallInprogress = false;
            // },
            //API call to get existing reminder details
            async getToolsReminders() {
                this.ajaxCallInprogress = true;
                let response = await this.GetToolReminderById(this.mode_id, this.recurring_id)
                this.old_reminder_data = response.response.repeat_details.repeat_cycle_type
                let rem_type = response.response.reminder_type
                this.reminder_name = response.response.reminder_title
                this.reminder_status = response.response.status
                this.origin = response.response.origin
                this.due_date = response.response.remind_date
                this.due_time = response.response.remind_time
                this.remind_period = response.response.remind_cycle_period
                this.remind_cycle = response.response.remind_cycle_type
                // user_id of the creator
                this.reminder_creator = response.response.created_by
                // this.repeatcheck = response.response.repeat
                // this.repeat_start_date = response.response.repeat_start_date
                // this.repeat_end_date = response.response.repeat_end_date
                // this.reminder_gap  = response.response.repeat_cycle_type == null ? "" : response.response.repeat_cycle_type
                // this.reminder_number = response.response.repeat_cycle_period
                this.assigned_to = response.response.invitees
                this.attachments = response.response.attachments
                this.followup_notes = response.response.notes
                this.repeat_reminder = response.response.repeat_details.repeat_cycle_type
                // Show/Hide the Edit button and Mark as complete buttons
                // this.can_edit= response.response.is_edit
                // this.can_mark_complete= response.response.is_mark_complete
                this.ajaxCallInprogress = false;
                if(this.repeat_reminder == "never"){
                    this.repeat_reminder = "Does not Repeat"
                } else if(this.repeat_reminder == "daily"){
                    this.repeat_reminder = "Daily"
                } else if(this.repeat_reminder == "weekly"){
                    this.repeat_reminder = "Weekly on Today's day"
                } else if(this.repeat_reminder == "monthly"){
                    this.repeat_reminder = "Monthly"
                } else if(this.repeat_reminder == "annually"){
                    this.repeat_reminder = "Annually"
                } else if(this.repeat_reminder == "weekdays"){
                    this.repeat_reminder = "Every Weekdays(Monday to Friday)"
                } else if(this.repeat_reminder == "weekends"){
                    this.repeat_reminder = "Every Weekends(Saturday and Sunday)"
                }
                if(this.reminder_gap == 'minute'){
                    if(response.response.repeat_cycle_type){
                        this.reminder_gap = 'Minute'
                    } 
                } else if(this.reminder_gap == 'hour'){
                    if(response.response.repeat_cycle_type){
                        this.reminder_gap = 'Hour'
                    } 
                } else if(this.reminder_gap == 'day'){
                    if(response.response.repeat_cycle_type){
                        this.reminder_gap = 'Day'
                    } 
                } else if(this.reminder_gap == 'month'){
                    if(response.response.repeat_cycle_type){
                        this.reminder_gap = 'Month'
                    } 
                } else if(this.reminder_gap == 'year'){
                    if(response.response.repeat_cycle_type){
                        this.reminder_gap = 'Year'
                    } 
                } 
                if(this.remind_cycle == 'minute'){
                    if(response.response.remind_period < 2){
                        this.temp_remind_cycle = 'Minute'
                    } else {
                        this.temp_remind_cycle = 'Minutes'
                    }
                } else if(this.remind_cycle == 'hour'){
                    if(response.response.remind_period < 2){
                        this.temp_remind_cycle = 'Hour'
                    } else {
                        this.temp_remind_cycle = 'Hours'
                    }
                } else if(this.remind_cycle == 'day'){
                    if(response.response.remind_period < 2){
                        this.temp_remind_cycle = 'Day'
                    } else {
                        this.temp_remind_cycle = 'Days'
                    }
                }
                if (rem_type == 'event') {
                    this.reminder_type = 'Event'
                    this.event_date = response.response.start_date
                    this.event_time = response.response.start_time
                    this.selected_invitees = response.response.invitees
                    response.response.invitees.forEach((x) => {
                        this.fetchMembersDataById(x.email)
                    })
                    setTimeout(() => {
                        this.selected_invitees = []
                        this.store_invitees.forEach(x => {
                            this.selected_invitees.push(x)
                        })
                        this.members_loading = false
                    }, 3000);
                    this.selected_event_products = response.response.products
                    this.event_notes = response.response.notes
                } else if (rem_type == 'task') {
                    this.reminder_type = 'Task'
                    // this.assigned_to = {
                    //     user_id: response.response.assigned_to,
                    //     full_name: response.response.assigned_to_name
                    // }
                    if(this.from_notification){
                        if(this.loggedInUser.user_id != this.assigned_to.user_id){
                            this.reminderType = 'Invitations'
                        }
                    }
                    let temp_selected_followup_products = []
                    let temp_products = response.response.products
                    temp_products.forEach((el_product, el_product_index) => {
                        temp_selected_followup_products.push({
                            id: el_product.id,
                            name: el_product.name
                        })
                    })
                    this.selected_event_products = temp_selected_followup_products
                    //this.taskrem_notes = response.response.extra_fields.notes
                    this.stringified_response = JSON.stringify(this.JSON_data)
                    this.$forceUpdate();
                } else if (rem_type == 'follow_up') {
                    this.reminder_type = 'Follow Up'
                    // this.assigned_to = {
                    //     user_id: response.response.assigned_to,
                    //     full_name: response.response.assigned_to_name
                    // }
                    if(this.from_notification){
                        if(this.loggedInUser.user_id != this.assigned_to.user_id){
                            this.reminderType = 'Invitations'
                        }
                    }
                    // this.price = response.response.price
                    // this.followup_notes = response.response.notes
                    let temp_selected_followup_products = []
                    let temp_products = response.response.products
                    temp_products.forEach((el_product, el_product_index) => {
                        temp_selected_followup_products.push({
                            id: el_product.id,
                            name: el_product.name
                        })
                    })
                    this.selected_event_products = temp_selected_followup_products
                    this.stringified_response = JSON.stringify(this.JSON_data)
                    this.$forceUpdate();
                }
                var curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
                if(this.due_date == curr_date){
                    var temp_start_time = ""
                    var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                    if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                        temp_start_time = curr_time.slice(0,3) + '00'
                    } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                        temp_start_time = curr_time.slice(0,3) + '15'
                    } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                        temp_start_time = curr_time.slice(0,3) + '30'
                    } else if(parseInt(curr_time.substring(3)) >= 45){
                        temp_start_time = curr_time.slice(0,3) + '45'
                    }
                    let indx = this.time_format.indexOf(temp_start_time)
                    this.time_format.splice(0,indx+1)
                }
                let startDate = new Date(this.due_date)
                startDate.setDate(startDate.getDate() + 1)
                this.disable_repeat_start_date = startDate
                var date1 = new Date(this.repeat_start_date);
                var date2 = new Date(this.repeat_end_date);
                var Difference_In_Time = date2.getTime()  - date1.getTime();
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
                if(this.repeat_start_date == this.repeat_end_date){
                    this.cycle_options = ['Minute','Hour']
                } if(Difference_In_Days >= 1) {
                    this.cycle_options = ['Minute','Hour' ,'Day']
                } if(Difference_In_Days > 30) {
                    this.cycle_options = ['Minute','Hour' ,'Day', 'Month']
                } if(Difference_In_Days > 365) {
                    this.cycle_options = ['Minute','Hour' ,'Day', 'Month', 'Year']
                }
                this.followupSetReminderOptions();
                this.ajaxCallInprogress = false;
            },
        },
        computed: {
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            JSON_data(){
                return {
                    reminder_title: this.reminder_name,
                    reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
                    remind_date: this.due_date,
                    remind_time: this.due_time,
                    repeat: this.repeat_reminder,
                    remind_cycle_type: this.remind_cycle.toLowerCase(),
                    remind_cycle_period: this.remind_period,
                    notes: this.followup_notes,
                    attachments: this.attachments,
                    invitees: this.assigned_to,
                    products: this.selected_event_products
                }
            },
            // ContactJSONData() {
            //     return {
            //         reminder_title: this.reminder_name,
            //         reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
            //         origin:"contacts",
            //         reference_id:this.$route.params.id,
            //         remind_date: this.due_date,
            //         remind_time: this.due_time,
            //         remind_cycle_type: this.remind_cycle.toLowerCase(),
            //         remind_cycle_period: this.remind_period,
            //         assigned_to: this.assigned_to.user_id,
            //         assigned_to_name: this.assigned_to.full_name,
            //         repeat: this.repeatcheck,
            //         repeat_start_date: this.repeat_start_date,
            //         repeat_end_date: this.repeat_end_date,
            //         repeat_cycle_type: this.reminder_gap.toLowerCase(),
            //         repeat_cycle_period: this.repeatcheck ? this.reminder_number : '0',
            //         notes: this.followup_notes,
            //         invitees: [],
            //         products: this.selected_followup_products.map(x => x.id)
            //     }
            // },
            // CustomerJSONData() {
            //     return {
            //         reminder_title: this.reminder_name,
            //         reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
            //         origin:"customers",
            //         reference_id:this.$route.params.id,
            //         remind_date: this.due_date,
            //         remind_time: this.due_time,
            //         remind_cycle_type: this.remind_cycle.toLowerCase(),
            //         remind_cycle_period: this.remind_period,
            //         assigned_to: this.assigned_to.user_id,
            //         assigned_to_name: this.assigned_to.full_name,
            //         repeat: this.repeatcheck,
            //         repeat_start_date: this.repeat_start_date,
            //         repeat_end_date: this.repeat_end_date,
            //         repeat_cycle_type: this.reminder_gap.toLowerCase(),
            //         repeat_cycle_period: this.repeatcheck ? this.reminder_number : '0',
            //         notes: this.followup_notes,
            //         invitees: [],
            //         products: this.selected_followup_products.map(x => x.id)
            //     }
            // },
            // LeadsJSONData() {
            //     return {
            //         reminder_title: this.reminder_name,
            //         reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
            //         origin:"leads",
            //         reference_id:this.$route.params.id,
            //         stage_name: this.stage_edit_mode == 'off' ? this.lead_current_stage : this.lead_edit_stage,
            //         remind_date: this.due_date,
            //         remind_time: this.due_time,
            //         remind_cycle_type: this.remind_cycle.toLowerCase(),
            //         remind_cycle_period: this.remind_period,
            //         assigned_to: this.assigned_to.user_id,
            //         assigned_to_name: this.assigned_to.full_name,
            //         repeat: this.repeatcheck,
            //         repeat_start_date: this.repeat_start_date,
            //         repeat_end_date: this.repeat_end_date,
            //         repeat_cycle_type: this.reminder_gap.toLowerCase(),
            //         repeat_cycle_period: this.repeatcheck ? this.reminder_number : '0',
            //         notes: this.followup_notes,
            //         invitees: [],
            //         products: this.selected_followup_products.map(x => x.id)
            //     }
            // },
            // RemindersJSONData() {
            //     return {
            //         reminder_title: this.reminder_name,
            //         reminder_type: this.reminder_type.replace(/\s+/g, "_").toLowerCase(),
            //         origin:"reminders",
            //         reference_id:"",
            //         // stage_name: this.stage_edit_mode == 'off' ? this.lead_current_stage : this.lead_edit_stage,
            //         remind_date: this.due_date,
            //         remind_time: this.due_time,
            //         remind_cycle_type: this.remind_cycle.toLowerCase(),
            //         remind_cycle_period: this.remind_period,
            //         // assigned_to: this.assigned_to.user_id,
            //         // assigned_to_name: this.assigned_to.full_name,
            //         // repeat: this.repeatcheck,
            //         // repeat_start_date: this.repeat_start_date,
            //         // repeat_end_date: this.repeat_end_date,
            //         repeat_cycle_type: this.repeat_reminder,
            //         // repeat_cycle_period: this.repeatcheck ? this.reminder_number : '0',
            //         notes: this.followup_notes,
            //         attachments: [],
            //         invitees: [],
            //         products: this.selected_followup_products.map(x => x.id)
            //     }
            // },
            // FollowUpJSONData() {
            //     return {
            //         name: this.reminder_name,
            //         type: 'follow_up',
            //         date: this.due_date,
            //         time: this.due_time,
            //         remind_cycle: this.remind_cycle,
            //         remind_period: this.remind_period,
            //         assigned_to: this.assigned_to.user_id,
            //         assigned_to_name: this.assigned_to.full_name,
            //         price: this.price,
            //         notes: this.followup_notes,
            //         invitees: [],
            //         products: this.selected_followup_products.map(x => x.id)
            //     }
            // },
            // EventJSONData() {
            //     return {
            //         name: this.reminder_name,
            //         type: 'event',
            //         date: this.event_date,
            //         time: this.event_time,
            //         remind_cycle: this.remind_cycle,
            //         remind_period: this.remind_period,
            //         assigned_to: '',
            //         assigned_to_name: '',
            //         price: '',
            //         notes: this.event_notes,
            //         invitees: this.selected_invitees.map(({
            //             user_id,
            //             email
            //         }) => {
            //             return {
            //                 'email': email,
            //                 'id': user_id
            //             }
            //         }),
            //         products: this.selected_event_products.map(x => x.id)
            //     }
            // },
            // TaskRemJSONData() {
            //     return {
            //         name: this.reminder_name,
            //         type: 'task',
            //         date: this.reminding_date,
            //         time: this.reminding_time,
            //         remind_cycle: this.remind_cycle,
            //         remind_period: this.remind_period,
            //         assigned_to: this.assigned_to.user_id,
            //         assigned_to_name: this.assigned_to.full_name,
            //         price: '',
            //         notes: this.taskrem_notes,
            //         invitees: [],
            //         products: this.selected_taskrem_products.map(x => x.id)
            //     }
            // },
            searchProuctName(){
                return debounce(this.searchProuctNameDebouncer, 500)
            },
            searchMembersData(){
                return debounce(this.searchMembersDataDebouncer, 500)
            },
            searchInvitedMembersData(){
                return debounce(this.searchInvitedMembersDataDebouncer, 500)
            },
            searchProduct(){
                return debounce(this.searchProductDebouncer, 500)
            },
            fields_not_changed(){
                return this.stringified_response == JSON.stringify(this.JSON_data)
            }
        },
        mounted() {
            if(this.meeting_type == 'meeting' && this.view_mode =='create'){
                this.schedule_meeting = true
                this.getMeetingData();
            }
            this.currency = this.loggedInUser.currency.symbol;
            if ((this.view_mode == 'view') || (this.view_mode == 'edit')) {
                this.ajaxCallInprogress = true;
                    this.getToolsReminders()
                // if (this.from_module == 'contact') {
                //     this.getContactReminders()
                // } else  if (this.from_module == 'customer') {
                //     this.getCustomerReminders()
                // } else  if (this.from_module == 'leads') {
                //     this.getLeadsReminders()
                // }else {
                //     this.getToolsReminders()
                // } 
            } 
        },
    })
    /*
    '00:00',
    '00:15',
    '00:30',
    '00:45',
    '01:00',
    '01:15',
    '01:30',
    '01:45',
    '02:00',
    '02:15',
    '02:30',
    '02:45',
    '03:00',
    '03:15',
    '03:30',
    '03:45',
    '04:00',
    '04:15',
    '04:30',
    '04:45',
    '05:00',
    '05:15',
    '05:30',
    '05:45',
    '06:00',
    '06:15',
    '06:30',
    '06:45',
    '07:00',
    '07:15',
    '07:30',
    '07:45',
    '08:00',
    '08:15',
    '08:30',
    '08:45',
    '09:00',
    '09:15',
    '09:30',
    '09:45',
    '10:00',
    '10:15',
    '10:30',
    '10:45',
    '11:00',
    '11:15',
    '11:30',
    '11:45',
    '12:00',
    '12:15',
    '12:30',
    '12:45',
    '13:00',
    '13:15',
    '13:30',
    '13:45',
    '14:00',
    '14:15',
    '14:30',
    '14:45',
    '15:00',
    '15:15',
    '15:30',
    '15:45',
    '16:00',
    '16:15',
    '16:30',
    '16:45',
    '17:00',
    '17:15',
    '17:30',
    '17:45',
    '18:00',
    '18:15',
    '18:30',
    '18:45',
    '19:00',
    '19:15',
    '19:30',
    '19:45',
    '20:00',
    '20:15',
    '20:30',
    '20:45',
    '21:00',
    '21:15',
    '21:30',
    '21:45',
    '22:00',
    '22:15',
    '22:30',
    '22:45',
    '23:00',
    '23:15',
    '23:30',
    '23:45',
    */
</script>
<style scoped>
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #005dae;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }

    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        color: black;
        font-size: 14px !important;
        font-weight: 600;
    }

    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .iconsize-16{
        line-height: 21px !important;
    }
    .input-field.price-field::placeholder {
        font-weight: 600 !important;
		color: #000 !important;
    }

	.input-field.price-field::-webkit-input-placeholder { /* Edge */
		font-weight: 600 !important;
		color: #000 !important;
	}

	.input-field.price-field:-ms-input-placeholder { /* Internet Explorer 10-11 */
		font-weight: 600 !important;
		color: #000 !important;
	}
    .upload-img {
        margin-left: 52px;
        width: 42px;
        margin-bottom: 12px;
    }
    .attachment-bg{
        background-color: #fff !important;
        border-radius: 6px !important;
        border: 2px dashed gray !important;
        height: 150px !important;
        margin: 10px 0px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Reminders/CreateReminder.vue